import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import "./users.css";
import axios from "axios";
import { Box, Button, Container, Table, Pagination, TableBody, TableCell, TableHead, TableRow, TextField, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Chip, Autocomplete } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import swal from "sweetalert";
import { t } from "i18next";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (config.data && config.data.id === undefined && config.data.userId) {

        }
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);


const getDisplayBankName = (userObj) => {
    if (!userObj) return "";
    const fn = String(userObj.name_stk || userObj.name || userObj.fullname || "").trim().toLowerCase();
    const b1 = String(userObj.bank || "").trim();
    const b2 = String(userObj.name_bank || "").trim();

    if (b1 && b1.toLowerCase() !== fn) return b1;
    if (b2 && b2.toLowerCase() !== fn) return b2;
    if (b1 && b1.toLowerCase() === fn) return "";
    if (b2 && b2.toLowerCase() === fn) return "";
    return "";
};

const removeAccentsAndUppercase = (str) => {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D")
        .toUpperCase()
        .trim();
};

const formatPhone = (phone) => {
    if (phone === undefined || phone === null || phone === "") return "-";
    const str = String(phone).trim();
    if (!str) return "-";
    return str.startsWith("0") ? str : "0" + str;
};

const formatNumberWithCommas = (val) => {
    if (val === undefined || val === null || val === "") return "";
    const clean = String(val).replace(/,/g, "").replace(/\D/g, "");
    if (!clean) return "";
    return Number(clean).toLocaleString("en-US");
};

const parseNumberFromCommas = (valStr) => {
    if (!valStr) return 0;
    const clean = String(valStr).replace(/,/g, "").replace(/\D/g, "");
    return Number(clean || 0);
};

const chimMoiOptions = [
    { label: "TẤT CẢ GAME", value: "all" },
    { label: "Tài Xỉu MD5", value: "md560s" },
    { label: "Xổ Số 75s", value: "xs75s" },
    { label: "Xổ Số 120s", value: "xs120s" },

    { label: "TX 45s - Sảnh 1", value: "tx45ssanh1" },
    { label: "TX 45s - Sảnh 2", value: "tx45ssanh2" },
    { label: "TX 45s - Sảnh 3", value: "tx45ssanh3" },
    { label: "TX 45s - Sảnh 4", value: "tx45ssanh4" },
    { label: "TX 45s - Sảnh 6", value: "tx45ssanh6" },

    { label: "TX 60s - Sảnh 1", value: "tx60ssanh1" },
    { label: "TX 60s - Sảnh 2", value: "tx60ssanh2" },
    { label: "TX 60s - Sảnh 3", value: "tx60ssanh3" },
    { label: "TX 60s - Sảnh 4", value: "tx60ssanh4" },
    { label: "TX 60s - Sảnh 5", value: "tx60ssanh5" },
    { label: "TX 60s - Sảnh 6", value: "tx60ssanh6" },

    { label: "XĐ 45s - Sảnh 1", value: "xd45ssanh1" },
    { label: "XĐ 45s - Sảnh 2", value: "xd45ssanh2" },
    { label: "XĐ 45s - Sảnh 3", value: "xd45ssanh3" },
    { label: "XĐ 45s - Sảnh 4", value: "xd45ssanh4" },
    { label: "XĐ 45s - Sảnh 5", value: "xd45ssanh5" },
    { label: "XĐ 45s - Sảnh 6", value: "xd45ssanh6" },

    { label: "XĐ 60s - Sảnh 1", value: "xd60ssanh1" },
    { label: "XĐ 60s - Sảnh 2", value: "xd60ssanh2" },
    { label: "XĐ 60s - Sảnh 3", value: "xd60ssanh3" },
    { label: "XĐ 60s - Sảnh 4", value: "xd60ssanh4" },
    { label: "XĐ 60s - Sảnh 5", value: "xd60ssanh5" },
    { label: "XĐ 60s - Sảnh 6", value: "xd60ssanh6" },

    { label: "Baccarat 60s - Sảnh A (1)", value: "baccarat60ssanh1" },
    { label: "Baccarat 60s - Sảnh B (2)", value: "baccarat60ssanh2" },
    { label: "Baccarat 60s - Sảnh C (3)", value: "baccarat60ssanh3" },
    { label: "Baccarat 60s - Sảnh D (4)", value: "baccarat60ssanh4" },
    { label: "Baccarat 60s - Sảnh E (5)", value: "baccarat60ssanh5" },
    { label: "Baccarat 60s - Sảnh F (6)", value: "baccarat60ssanh6" },

    { label: "Bầu Cua 45s - Sảnh A (1)", value: "baucua45ssanh1" },
    { label: "Bầu Cua 45s - Sảnh B (2)", value: "baucua45ssanh2" },
    { label: "Bầu Cua 45s - Sảnh C (3)", value: "baucua45ssanh3" },
    { label: "Bầu Cua 45s - Sảnh D (4)", value: "baucua45ssanh4" },

    { label: "Bầu Cua 60s - Sảnh A (1)", value: "baucua60ssanh1" },
    { label: "Bầu Cua 60s - Sảnh B (2)", value: "baucua60ssanh2" },
    { label: "Bầu Cua 60s - Sảnh C (3)", value: "baucua60ssanh3" },
    { label: "Bầu Cua 60s - Sảnh D (4)", value: "baucua60ssanh4" },

    { label: "Rồng Hổ 45s - Sảnh A (1)", value: "rongho45ssanh1" },
    { label: "Rồng Hổ 45s - Sảnh B (2)", value: "rongho45ssanh2" },
    { label: "Rồng Hổ 45s - Sảnh C (3)", value: "rongho45ssanh3" },
    { label: "Rồng Hổ 45s - Sảnh D (4)", value: "rongho45ssanh4" },

    { label: "Rồng Hổ 60s - Sảnh A (1)", value: "rongho60ssanh1" },
    { label: "Rồng Hổ 60s - Sảnh B (2)", value: "rongho60ssanh2" },
    { label: "Rồng Hổ 60s - Sảnh C (3)", value: "rongho60ssanh3" },
    { label: "Rồng Hổ 60s - Sảnh D (4)", value: "rongho60ssanh4" },

    { label: "XD Blockchain 45s - Sảnh A (1)", value: "xocdiablockchain45ssanh1" },
    { label: "XD Blockchain 45s - Sảnh B (2)", value: "xocdiablockchain45ssanh2" },
    { label: "XD Blockchain 45s - Sảnh C (3)", value: "xocdiablockchain45ssanh3" },
    { label: "XD Blockchain 45s - Sảnh D (4)", value: "xocdiablockchain45ssanh4" },

    { label: "XD Blockchain 60s - Sảnh A (1)", value: "xocdiablockchain60ssanh1" },
    { label: "XD Blockchain 60s - Sảnh B (2)", value: "xocdiablockchain60ssanh2" },
];

const defaultBankList = [
    { name: "Ngân hàng TMCP Ngoại Thương Việt Nam", short_name: "Vietcombank", code: "VCB" },
    { name: "Ngân hàng TMCP Công Thương Việt Nam", short_name: "VietinBank", code: "ICB" },
    { name: "Ngân hàng TMCP Đầu tư và Phát triển Việt Nam", short_name: "BIDV", code: "BIDV" },
    { name: "Ngân hàng Nông nghiệp và Phát triển Nông thôn Việt Nam", short_name: "Agribank", code: "VBA" },
    { name: "Ngân hàng TMCP Phương Đông", short_name: "OCB", code: "OCB" },
    { name: "Ngân hàng TMCP Quân Đội", short_name: "MBBank", code: "MB" },
    { name: "Ngân hàng TMCP Kỹ Thương Việt Nam", short_name: "Techcombank", code: "TCB" },
    { name: "Ngân hàng TMCP Á Châu", short_name: "ACB", code: "ACB" },
    { name: "Ngân hàng TMCP Việt Nam Thịnh Vượng", short_name: "VPBank", code: "VPB" },
    { name: "Ngân hàng TMCP Tiên Phong", short_name: "TPBank", code: "TPB" },
    { name: "Ngân hàng TMCP Sài Gòn Thương Tín", short_name: "Sacombank", code: "STB" },
    { name: "Ngân hàng TMCP Phát triển TP.HCM", short_name: "HDBank", code: "HDB" },
    { name: "Ngân hàng TMCP Bản Việt", short_name: "VietCapitalBank", code: "VCCB" },
    { name: "Ngân hàng TMCP Sài Gòn", short_name: "SCB", code: "SCB" },
    { name: "Ngân hàng TMCP Quốc Tế", short_name: "VIB", code: "VIB" },
    { name: "Ngân hàng TMCP Sài Gòn - Hà Nội", short_name: "SHB", code: "SHB" },
    { name: "Ngân hàng TMCP Xuất Nhập Khẩu", short_name: "Eximbank", code: "EIB" },
    { name: "Ngân hàng TMCP Hàng Hải", short_name: "MSB", code: "MSB" },
    { name: "TMCP Việt Nam Thịnh Vượng - Ngân hàng số CAKE by VPBank", short_name: "CAKE", code: "CAKE" },
    { name: "Ngân hàng số Ubank by VPBank", short_name: "Ubank", code: "Ubank" },
    { name: "Viettel Money", short_name: "ViettelMoney", code: "VTLMONEY" },
    { name: "Ngân hàng số Timo", short_name: "Timo", code: "TIMO" },
    { name: "VNPT Money", short_name: "VNPTMoney", code: "VNPTMONEY" },
    { name: "Ngân hàng TMCP Sài Gòn Công Thương", short_name: "SaigonBank", code: "SGICB" },
    { name: "Ngân hàng TMCP Bắc Á", short_name: "BacABank", code: "BAB" },
    { name: "Ví MoMo", short_name: "MoMo", code: "momo" },
    { name: "Ngân hàng TMCP Đại Chúng Việt Nam", short_name: "PVcomBank", code: "PVCB" },
    { name: "Ngân hàng TMCP Quốc Dân", short_name: "NCB", code: "NCB" },
    { name: "Ngân hàng Shinhan Việt Nam", short_name: "ShinhanBank", code: "SHBVN" },
    { name: "Ngân hàng TMCP An Bình", short_name: "ABBANK", code: "ABB" },
    { name: "Ngân hàng TMCP Việt Á", short_name: "VietABank", code: "VAB" },
    { name: "Ngân hàng TMCP Nam Á", short_name: "NamABank", code: "NAB" },
    { name: "Ngân hàng TMCP Xăng Dầu Petrolimex", short_name: "PGBank", code: "PGB" },
    { name: "Ngân hàng TMCP Việt Nam Thương Tín", short_name: "VietBank", code: "VIETBANK" },
    { name: "Ngân hàng TMCP Bảo Việt", short_name: "BaoVietBank", code: "BVB" },
    { name: "Ngân hàng TMCP Đông Nam Á", short_name: "SeABank", code: "SEAB" },
    { name: "Ngân hàng Hợp tác xã Việt Nam", short_name: "COOPBANK", code: "COOPBANK" },
    { name: "Ngân hàng TMCP Lộc Phát Việt Nam", short_name: "LPBank", code: "LPB" },
    { name: "Ngân hàng TMCP Kiên Long", short_name: "KienLongBank", code: "KLB" },
    { name: "Ngân hàng KBank", short_name: "KBank", code: "KBank" },
    { name: "Ngân hàng Hong Leong Việt Nam", short_name: "HongLeong", code: "HLBVN" },
    { name: "Ngân hàng KEB Hana - CN Hà Nội", short_name: "KEBHANAHN", code: "KEBHANAHN" },
    { name: "Ngân hàng KEB Hana - CN HCM", short_name: "KEBHanaHCM", code: "KEBHANAHCM" },
    { name: "Ngân hàng Citibank N.A. - Chi nhánh Hà Nội", short_name: "Citibank", code: "CITIBANK" },
    { name: "Ngân hàng Thương mại TNHH MTV Xây dựng Việt Nam", short_name: "CBBank", code: "CBB" },
    { name: "Ngân hàng TNHH MTV CIMB Việt Nam", short_name: "CIMB", code: "CIMB" },
    { name: "Ngân hàng DBS Bank", short_name: "DBSBank", code: "DBS" },
    { name: "Ngân hàng Chính sách Xã hội", short_name: "VBSP", code: "VBSP" },
    { name: "Ngân hàng Dầu Khí Toàn Cầu", short_name: "GPBank", code: "GPB" },
    { name: "Ngân hàng Kookmin - HCM", short_name: "KookminHCM", code: "KBHCM" },
    { name: "Ngân hàng Kookmin - Hà Nội", short_name: "KookminHN", code: "KBHN" },
    { name: "Ngân hàng Woori Việt Nam", short_name: "Woori", code: "WVN" },
    { name: "Ngân hàng Liên doanh Việt Nga", short_name: "VRB", code: "VRB" },
    { name: "Ngân hàng HSBC Việt Nam", short_name: "HSBC", code: "HSBC" },
    { name: "Ngân hàng United Overseas Bank", short_name: "UnitedOverseas", code: "UOB" },
    { name: "Ngân hàng Standard Chartered Việt Nam", short_name: "StandardChartered", code: "SCVN" },
    { name: "Ngân hàng Public Bank Việt Nam", short_name: "PublicBank", code: "PBVN" },
];

const GAME_PROVIDERS = [
    { code: "EVO", name: "Evolution", status: "Hoạt động", logo: "evo.png" },
    { code: "PP", name: "Pragmatic Play", status: "Hoạt động", logo: "pp.png" },
    { code: "DG", name: "Dream Gaming", status: "Hoạt động", logo: "dg.png" },
    { code: "WM", name: "WM Casino", status: "Hoạt động", logo: "wm.png" },
    { code: "SEXY", name: "AE Sexy", status: "Hoạt động", logo: "sexy.png" },
    { code: "SA", name: "SA Gaming", status: "Hoạt động", logo: "sa.png" },
    { code: "PG", name: "PG Soft", status: "Hoạt động", logo: "pg.png" },
    { code: "JDB", name: "JDB Gaming", status: "Hoạt động", logo: "jdb.png" },
    { code: "CQ9", name: "CQ9 Gaming", status: "Hoạt động", logo: "cq9.png" },
    { code: "SABA", name: "SABA Sports", status: "Hoạt động", logo: "saba.png" },
    { code: "CMD", name: "CMD368", status: "Hoạt động", logo: "cmd.png" },
    { code: "UG", name: "United Gaming", status: "Hoạt động", logo: "ug.png" }
];

function CustomBankSelect({ value, onChange, options }) {
    const listToUse = (options && options.length > 0) ? options : defaultBankList;

    const bankOptions = listToUse.map(b => {
        const name = b.name || b.name_bank || "";
        const shortName = b.short_name || "";
        const code = b.code || "";
        const label = shortName
            ? (name ? shortName + " - " + name : shortName)
            : (code ? code + " - " + name : name);
        return {
            ...b,
            _label: label,
            _value: shortName || name || code,
        };
    });

    const valStr = String(value || "").trim().toLowerCase();
    const selectedOption = bankOptions.find(b => {
        const n = String(b.name || b.name_bank || "").toLowerCase();
        const c = String(b.code || b.short_name || "").toLowerCase();
        const sn = String(b.short_name || "").toLowerCase();
        return (valStr && (n === valStr || c === valStr || sn === valStr));
    }) || null;

    return (
        <Autocomplete
            size="small"
            fullWidth
            forcePopupIcon={!selectedOption}
            options={bankOptions}
            value={selectedOption}
            onChange={(e, newVal) => {
                onChange(newVal ? newVal._value : "");
            }}
            getOptionLabel={(opt) => opt._label || ""}
            isOptionEqualToValue={(opt, val) => opt._value === val._value}
            componentsProps={{ popper: { style: { zIndex: 999999 } } }}
            slotProps={{
                popper: {
                    sx: {
                        zIndex: 999999,
                        "& .MuiAutocomplete-paper": {
                            backgroundColor: "#ffffff !important",
                            color: "#1e293b !important",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.15) !important",
                        },
                        "& .MuiAutocomplete-option": {
                            color: "#1e293b !important",
                            fontSize: "13px !important",
                            padding: "8px 12px !important",
                            "&:hover": {
                                backgroundColor: "#f1f5f9 !important",
                                color: "#0f172a !important",
                            },
                            "&[aria-selected='true']": {
                                backgroundColor: "#e2e8f0 !important",
                                color: "#0f172a !important",
                                fontWeight: "600 !important",
                            }
                        }
                    }
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    placeholder="-- Chọn ngân hàng --"
                    sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                            fontSize: "13px",
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            width: "100%",
                            paddingRight: "28px !important",
                        },
                        "& .MuiInputBase-input": {
                            fontSize: "13px",
                            fontWeight: 400,
                            color: "#1e293b !important",
                            textOverflow: "ellipsis",
                            paddingRight: "0px !important",
                        },
                        "& .MuiAutocomplete-endAdornment": {
                            right: "4px",
                        }
                    }}
                />
            )}
            renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                    <li key={key || option._id || option.code || option._value} {...optionProps} style={{ fontSize: "13px", padding: "7px 12px", fontWeight: 400, color: "#1e293b" }}>
                        {option._label}
                    </li>
                );
            }}
            noOptionsText="Không tìm thấy ngân hàng"
            clearText="Xoá"
            sx={{ width: "100%" }}
        />
    );
}
function Users() {
    const [users, setUsers] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchDraft, setSearchDraft] = useState("");
    const [fullNameFilter, setFullNameFilter] = useState("");
    const [passwordFilter, setPasswordFilter] = useState("");
    const [payPasswordFilter, setPayPasswordFilter] = useState("");
    const [selectedAgency, setSelectedAgency] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [openUserGuideModal, setOpenUserGuideModal] = useState(false);
    const [subModalType, setSubModalType] = useState(null);
    const [subModalHistoryData, setSubModalHistoryData] = useState([]);
    const [loadingSubHistory, setLoadingSubHistory] = useState(false);
    const [noteDetail, setNoteDetail] = useState("");
    const [recentNotes, setRecentNotes] = useState(() => {
        try {
            const saved = localStorage.getItem("admin_wallet_recent_notes");
            if (saved) {
                const parsed = JSON.parse(saved);
                if (Array.isArray(parsed) && parsed.length > 0) return parsed.slice(0, 5);
            }
            const single = localStorage.getItem("admin_wallet_recent_note");
            if (single) return [single];
        } catch (e) {}
        return ["KHUYẾN MÃI NẠP ĐẦU 50%"];
    });
    const [agencies, setAgencies] = useState([]);
    const [systemBanks, setSystemBanks] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();
    const isVipHistoryView = new URLSearchParams(location.search).get("view") === "vip-history";
    const typingTimeoutRef = useRef(null);
    const limit = 50;

    const [subHistoryStatus, setSubHistoryStatus] = useState("All");
    const [subHistoryStartDate, setSubHistoryStartDate] = useState("");
    const [subHistoryEndDate, setSubHistoryEndDate] = useState("");
    const [subHistoryLoaiGame, setSubHistoryLoaiGame] = useState("All");
    const [subHistorySanh, setSubHistorySanh] = useState("All");
    const [subHistoryTheLoai, setSubHistoryTheLoai] = useState("All");
    const [subHistoryMaCuoc, setSubHistoryMaCuoc] = useState("");
    const [subHistoryMaGiaoDich, setSubHistoryMaGiaoDich] = useState("");

    useEffect(() => {
        if (selectedUser && subModalType && ["nap", "rut", "cuoc", "chuyenquy", "dongdiem_his", "hoantra"].includes(subModalType)) {
            setLoadingSubHistory(true);
            setSubHistoryStatus("All");
            setSubHistoryStartDate("");
            setSubHistoryEndDate("");
            setSubHistoryLoaiGame("All");
            setSubHistorySanh("All");
            setSubHistoryTheLoai("All");
            setSubHistoryMaCuoc("");
            setSubHistoryMaGiaoDich("");

            if (subModalType === "nap") {
                axios.get(`${process.env.REACT_APP_API_URL}/payment/nap?search=${selectedUser.username}&limit=5000`)
                    .then((res) => {
                        setSubModalHistoryData(res.data.data || []);
                        setLoadingSubHistory(false);
                    })
                    .catch(() => {
                        setSubModalHistoryData([]);
                        setLoadingSubHistory(false);
                    });
            } else if (subModalType === "rut") {
                axios.get(`${process.env.REACT_APP_API_URL}/payment/rut?search=${selectedUser.username}&limit=5000`)
                    .then((res) => {
                        setSubModalHistoryData(res.data.data || []);
                        setLoadingSubHistory(false);
                    })
                    .catch(() => {
                        setSubModalHistoryData([]);
                        setLoadingSubHistory(false);
                    });
            } else {
                axios.get(`${process.env.REACT_APP_API_URL}/history/historyuser/${selectedUser._id}?limit=5000`)
                    .then((res) => {
                        setSubModalHistoryData(res.data.data || []);
                        setLoadingSubHistory(false);
                    })
                    .catch(() => {
                        setSubModalHistoryData([]);
                        setLoadingSubHistory(false);
                    });
            }
        }
    }, [selectedUser, subModalType]);

    useEffect(() => {
        if (selectedUser) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [selectedUser]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const hh = ("0" + d.getHours()).slice(-2);
        const mm = ("0" + d.getMinutes()).slice(-2);
        const DD = ("0" + d.getDate()).slice(-2);
        const MM = ("0" + (d.getMonth() + 1)).slice(-2);
        const YYYY = d.getFullYear();
        return `${hh}:${mm} ${DD}-${MM}-${YYYY}`;
    };

    const handleChangePage = (event, value) => {
        setPage(value);
    };

    const fetchUsers = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getall`, {
                params: {
                    page: page,
                    limit: limit,
                    search: searchQuery,
                    agency: selectedAgency
                }
            })
            .then((res) => {
                setUsers(res.data.data);
                setTotalPages(res.data.totalPages || 1);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    const fetchAgencies = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`)
            .then(res => {
                if (res.data && res.data.data) {
                    setAgencies(res.data.data);
                }
            })
            .catch(err => console.error("Lỗi lấy danh sách đại lý:", err));
    };

    useEffect(() => {
        fetchUsers();
        fetchAgencies();
        axios.get(`${process.env.REACT_APP_API_URL}/available-bank/list`)
            .then(res => {
                const bankData = res.data?.data;
                setSystemBanks(Array.isArray(bankData) ? bankData : (bankData?.data || []));
            })
            .catch(() => { });
    }, [page, searchQuery, selectedAgency]);

    const autoSaveField = (fieldPayload) => {
        if (!selectedUser) return;
        const payload = { id: selectedUser._id, ...fieldPayload };
        axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, payload)
            .then(() => {
                setSelectedUser(prev => ({ ...prev, ...fieldPayload }));
                fetchUsers();
            })
            .catch(() => { });
    };

    const handleSaveUserInfo = () => {
        if (!selectedUser) return;
        const rawFullname = document.getElementById("user_fullname")?.value || "";
        const fullname = removeAccentsAndUppercase(rawFullname);
        const sdt = document.getElementById("user_sdt")?.value || "";
        const paypwd = document.getElementById("user_paypwd")?.value || "";
        const curWag = Number(document.getElementById("cur_wagering")?.value || 0);
        const reqWagInput = Number(document.getElementById("req_wagering")?.value || 0);
        const reqWag = reqWagInput * 1000;
        const bankName = document.getElementById("user_bank_name")?.value || "";
        const bankStk = document.getElementById("user_bank_stk")?.value || "";
        const note = document.getElementById("user_note")?.value || "";

        const payload = {
            id: selectedUser._id,
            name: fullname,
            fullname: fullname,
            sdt: sdt.startsWith("0") ? sdt.substring(1) : sdt,
            paypwd: paypwd,
            current_wagering: curWag,
            required_wagering: reqWag,
            name_bank: bankName,
            bank: bankName,
            stk_bank: bankStk,
            stk: bankStk,
            note: note
        };

        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, payload)
            .then(() => {
                setLoading(false);
                setSelectedUser(prev => ({
                    ...prev,
                    ...payload
                }));
                fetchUsers();
            })
            .catch((err) => {
                setLoading(false);
                swal("Lỗi", err.response?.data?.message || "Cập nhật thất bại!", "error");
            });
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

        typingTimeoutRef.current = setTimeout(() => {
            setSearchQuery(value);
            setPage(1);
        }, 500);
    };

    const handlePlayerSearch = () => {
        setSearchQuery(searchDraft.trim());
        setPage(1);
    };

    const handleResetFilters = () => {
        setSearchDraft("");
        setFullNameFilter("");
        setPasswordFilter("");
        setPayPasswordFilter("");
        setSelectedAgency("");
        setSearchQuery("");
        setPage(1);
    };

    let visibleUsers = (users || []).filter((item) => {
        const fullName = item?.name || item?.fullname || "";
        const password = item?.password || item?.plainPassword || "";
        const payPassword = item?.paypwd || "";
        return fullName.toLowerCase().includes(fullNameFilter.toLowerCase())
            && password.toLowerCase().includes(passwordFilter.toLowerCase())
            && payPassword.toLowerCase().includes(payPasswordFilter.toLowerCase());
    });

    if (isVipHistoryView) {
        visibleUsers = [...visibleUsers].sort((a, b) => (b.level || 0) - (a.level || 0));
    }

    const exportUsers = () => {
        if (!visibleUsers.length) {
            swal("Thông báo", "Không có dữ liệu để xuất", "info");
            return;
        }
        const lines = [
            ["Tên đăng nhập", "Ví", "Số điểm cần cược", "Người mời", "Mật khẩu rút điểm"],
            ...visibleUsers.map((item) => [
                item?.username || "",
                Math.floor(Number(item?.money || 0) / 1000),
                Math.floor(Number(item?.required_wagering || item?.tongnap || 0) / 1000),
                item?.aff || "",
                item?.paypwd || ""
            ])
        ];
        const csv = lines.map((line) => line.map((value) => `"${String(value).replaceAll('"', '""')}"`).join(",")).join("\n");
        const url = URL.createObjectURL(new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8" }));
        const link = document.createElement("a");
        link.href = url;
        link.download = "danh-sach-nguoi-choi.csv";
        link.click();
        URL.revokeObjectURL(url);
    };

    const handleSetChimMoi = (userId, winValue) => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
            id: userId,
            win: winValue
        }).then(() => {
            fetchUsers();
            swal(t("success"), "Đã cập nhật tính năng Auto Win!", "success");
        }).catch(() => {
            setLoading(false);
            swal(t("error"), "Có lỗi xảy ra khi cập nhật!", "error");
        });
    };

    const handleSetAllLeyiRtp = () => {
        swal({
            text: "Nhập tỷ lệ thắng Leyi cho TẤT CẢ người chơi (30 - 90, hoặc 0 để tắt):",
            content: {
                element: "input",
                attributes: {
                    placeholder: "Ví dụ: 75",
                    type: "number",
                },
            },
            buttons: ["Hủy", "Xác nhận"]
        }).then((value) => {
            if (value === null) return; // Clicked cancel
            const rtpVal = Number(value);
            if (value !== "0" && (isNaN(rtpVal) || rtpVal < 30 || rtpVal > 90)) {
                swal("Lỗi", "Tỷ lệ thắng hợp lệ phải từ 30 đến 90, hoặc 0 để tắt!", "error");
                return;
            }
            setLoading(true);
            axios.post(`${process.env.REACT_APP_API_URL}/auth/updateAllRtp`, {
                leyi_rtp: rtpVal
            }).then(() => {
                fetchUsers();
                swal(t("success"), `Đã cập nhật tỷ lệ thắng Leyi: ${rtpVal}% cho tất cả người chơi!`, "success");
            }).catch((err) => {
                setLoading(false);
                swal(t("error"), err.response?.data?.message || "Có lỗi xảy ra khi cập nhật!", "error");
            });
        });
    };

    const handleMultiSelectChange = (userId, event) => {
        let selectedValues = event.target.value;

        if (selectedValues.includes("all")) {
            if (selectedValues[selectedValues.length - 1] === "all") {
                selectedValues = ["all"];
            } else {
                selectedValues = selectedValues.filter(val => val !== "all");
            }
        }
        const finalWinString = selectedValues.join(",");
        handleSetChimMoi(userId, finalWinString);
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" className="happy-users-page" sx={{ flexGrow: 1, py: 1 }}>
                    {loading && (
                        <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", bgcolor: "rgba(255, 255, 255, 0.5)", backdropFilter: "blur(2px)", zIndex: 99999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className="loader"></div>
                        </Box>
                    )}
                    <Container maxWidth={false} className="happy-users-container">
                        <div className="happy-users-header">
                            <button className="ax-guide-button" onClick={() => setOpenUserGuideModal(true)}>Hướng dẫn <span>?</span></button>
                        </div>
                        <div className="container_set">{isVipHistoryView ? "Lịch sử thăng cấp VIP" : t("users")}</div>
                        <div className="form_set happy-users-surface">
                            <Box>
                                <div className="happy-users-filter">
                                    <div className="happy-users-filter-item">
                                        <label>Tên người chơi</label>
                                        <input value={searchDraft} onChange={(event) => setSearchDraft(event.target.value)} onKeyDown={(event) => event.key === "Enter" && handlePlayerSearch()} />
                                    </div>
                                    <div className="happy-users-filter-item">
                                        <label>Họ và tên</label>
                                        <input value={fullNameFilter} onChange={(event) => setFullNameFilter(event.target.value)} />
                                    </div>
                                    <div className="happy-users-filter-item">
                                        <label>Mật khẩu</label>
                                        <input value={passwordFilter} onChange={(event) => setPasswordFilter(event.target.value)} />
                                    </div>
                                    <div className="happy-users-filter-item">
                                        <label>Mật khẩu rút điểm</label>
                                        <input value={payPasswordFilter} onChange={(event) => setPayPasswordFilter(event.target.value)} />
                                    </div>
                                    <div className="happy-users-filter-actions">
                                        <button className="search" onClick={handlePlayerSearch}>Tìm kiếm</button>
                                        <button className="refresh" onClick={() => { setSearchDraft(""); setFullNameFilter(""); setPasswordFilter(""); setPayPasswordFilter(""); fetchUsers(); }}>Làm mới</button>
                                        <button className="export" onClick={exportUsers}>Xuất excel</button>
                                    </div>
                                </div>
                            </Box>
                        </div>
                        <div className="happy-users-surface" style={{ padding: "0" }}>
                            <div className="table-responsive">
                                <Table className="table-admin happy-users-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "180px", width: "180px" }}>Họ và tên</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "130px" }}>{t("username")}</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "120px" }}>{t("phone")}</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "65px", width: "65px", paddingLeft: "6px", paddingRight: "6px" }}>Ví</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "130px" }}>Số điểm cần cược</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "110px" }}>Người mời</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "110px" }}>Mật khẩu</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "130px" }}>Mật khẩu rút điểm</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", minWidth: "130px" }}>{t("created")}</TableCell>
                                            <TableCell align="center" sx={{ whiteSpace: "nowrap", minWidth: "80px" }}>Tác vụ</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {visibleUsers.length > 0 ? (
                                            visibleUsers.map((item) => {
                                                const currentWinArray = item?.win ? item.win.split(',').map(s => s.trim()) : [];
                                                const displayAff = (!item?.aff || item?.aff === "admin") ? "" : item.aff;

                                                return (
                                                    <TableRow key={item._id} sx={{ verticalAlign: "middle", backgroundColor: item?.win ? "rgba(255, 0, 0, 0.05)" : "transparent" }}>
                                                        <TableCell sx={{ fontWeight: 600, color: "#1e293b", whiteSpace: "nowrap", minWidth: "180px", width: "180px" }}>
                                                            {removeAccentsAndUppercase(item?.name || item?.fullname || item?.name_stk || "CHƯA CẬP NHẬT")}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: item?.win ? "bold" : "600", color: item?.win ? "#d32f2f" : "#1565C0", whiteSpace: "nowrap", minWidth: "130px" }}>
                                                            {item?.username}
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap", minWidth: "120px" }}>{formatPhone(item?.sdt)}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", color: "#334155", whiteSpace: "nowrap", minWidth: "65px", width: "65px", paddingLeft: "6px", paddingRight: "6px" }}>{item?.money !== undefined && item?.money !== null ? Math.floor(Number(item.money) / 1000).toLocaleString("en-US") : 0}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap", minWidth: "130px" }}>{Math.floor(Number(item?.required_wagering !== undefined ? item?.required_wagering : (item?.tongnap || 0)) / 1000).toLocaleString("en-US")}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap", minWidth: "110px" }}>{displayAff}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                            {item?.password_raw || (item?.password && !item?.password.startsWith("$") ? item?.password : "")}
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap", color: "#475569" }}>{item?.paypwd || "Chưa cài"}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap", fontSize: "12px", color: "#64748b" }}>{formatDate(item?.createdAt)}</TableCell>
                                                        <TableCell align="center">
                                                            <Box sx={{ display: "flex", gap: 1, justifyContent: "center", alignItems: "center" }}>
                                                                <IconButton
                                                                    onClick={() => setSelectedUser(item)}
                                                                    title="Xem & Chỉnh sửa chi tiết"
                                                                    sx={{
                                                                        bgcolor: "#1e88e5",
                                                                        color: "#ffffff",
                                                                        borderRadius: "50%",
                                                                        padding: "8px",
                                                                        boxShadow: "0 2px 6px rgba(30, 136, 229, 0.3)",
                                                                        "&:hover": { bgcolor: "#1565c0" }
                                                                    }}
                                                                >
                                                                    <PersonIcon sx={{ fontSize: "18px" }} />
                                                                </IconButton>

                                                                <IconButton
                                                                    title={item?.isLock ? "Mở khóa tài khoản" : "Khóa tài khoản"}
                                                                    onClick={() => {
                                                                        setLoading(true);
                                                                        axios.post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, { id: item?._id, isLock: !item?.isLock })
                                                                            .then(() => {
                                                                                fetchUsers();
                                                                                swal(t("success"), "Đã cập nhật trạng thái tài khoản!", "success");
                                                                            }).catch(() => setLoading(false));
                                                                    }}
                                                                    sx={{
                                                                        bgcolor: item?.isLock ? "#4caf50" : "#ef5350",
                                                                        color: "#ffffff",
                                                                        borderRadius: "50%",
                                                                        padding: "8px",
                                                                        boxShadow: item?.isLock ? "0 2px 6px rgba(76, 175, 80, 0.3)" : "0 2px 6px rgba(239, 83, 80, 0.3)",
                                                                        "&:hover": { bgcolor: item?.isLock ? "#388e3c" : "#d32f2f" }
                                                                    }}
                                                                >
                                                                    {item?.isLock ? <LockOpenIcon sx={{ fontSize: "18px" }} /> : <LockIcon sx={{ fontSize: "18px" }} />}
                                                                </IconButton>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={12} align="center">{t('empty')}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            <Pagination
                                color="primary"
                                count={totalPages}
                                page={page}
                                onChange={handleChangePage}
                            />
                        </Box>
                    </Container>
                </Box>

                {selectedUser && (
                    <div className="ax-modal-overlay" onClick={() => setSelectedUser(null)}>
                        <div className="ax-user-modal-card" onClick={(e) => e.stopPropagation()}>
                            <div className="ax-modal-header">
                                <h3>
                                    Thông tin: <span>{selectedUser.username}</span>
                                </h3>
                                <span className="close-icon" onClick={() => setSelectedUser(null)}>✕</span>
                            </div>

                            {/* Unified Single Card 4-Column Grid Container (Identical to Reference Screenshot) */}
                            <div className="ax-user-card-box">
                                {/* Row 1 */}
                                <div className="ax-user-field-card">
                                    <label>UID</label>
                                    <div className="ax-user-val-text">{selectedUser.iduser || selectedUser.uid || selectedUser.id || "-"}</div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label>ID Sảnh</label>
                                    <div className="ax-user-val-text">{selectedUser._id || ""}</div>
                                </div>
                                <div className="ax-user-field-card ax-user-card-full">
                                    <label>Họ và tên</label>
                                    <input
                                        id="user_fullname"
                                        defaultValue={removeAccentsAndUppercase(selectedUser.name || selectedUser.fullname || "")}
                                        onInput={(e) => {
                                            e.target.value = removeAccentsAndUppercase(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            const val = removeAccentsAndUppercase(e.target.value);
                                            if (val !== removeAccentsAndUppercase(selectedUser.name || selectedUser.fullname || "")) {
                                                autoSaveField({ name: val, fullname: val });
                                            }
                                        }}
                                        placeholder="CHƯA CẬP NHẬT"
                                    />
                                </div>
                                <div className="ax-user-field-card ax-user-card-full">
                                    <label>Số điện thoại</label>
                                    <input id="user_sdt" defaultValue={selectedUser.sdt ? formatPhone(selectedUser.sdt) : ""} placeholder="Chưa có SĐT"
                                        onBlur={(e) => {
                                            const val = e.target.value;
                                            const sdtVal = val.startsWith("0") ? val.substring(1) : val;
                                            if (sdtVal !== (selectedUser.sdt || "")) {
                                                autoSaveField({ sdt: sdtVal });
                                            }
                                        }}
                                    />
                                </div>

                                {/* Row 2 */}
                                <div className="ax-user-field-card ax-user-card-full">
                                    <label className="lbl-blue">Người mới</label>
                                    <select
                                        defaultValue={(selectedUser.aff === "admin" ? "" : selectedUser.aff) || ""}
                                        onChange={(e) => {
                                            const newAff = e.target.value;
                                            setLoading(true);
                                            axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, { id: selectedUser._id, aff: newAff })
                                                .then(() => {
                                                    setLoading(false);
                                                    swal("Thành công", "Đã cập nhật người mời!", "success");
                                                    fetchUsers();
                                                }).catch(() => {
                                                    setLoading(false);
                                                    swal("Lỗi", "Cập nhật thất bại", "error");
                                                });
                                        }}
                                    >
                                        <option value="">-- Trống (Không có người mời) --</option>
                                        {agencies && agencies.filter(ag => ag.username !== "admin" && ag.code !== "admin").map(ag => (
                                            <option key={ag.code} value={ag.code}>{ag.username} (Mã: {ag.code})</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="ax-user-field-card">
                                    <label>Mật khẩu đăng nhập</label>
                                    <input
                                        id="user_login_password"
                                        defaultValue={selectedUser.password_raw || selectedUser.username || "******"}
                                        placeholder="Mật khẩu"
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.target.blur();
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const val = e.target.value.trim();
                                            const currentVal = selectedUser.password_raw || selectedUser.username || "";
                                            if (val && val !== currentVal && val !== "******") {
                                                setLoading(true);
                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, {
                                                    id: selectedUser._id,
                                                    password: val
                                                })
                                                    .then(() => {
                                                        setLoading(false);
                                                        setSelectedUser(prev => ({ ...prev, password_raw: val }));
                                                        swal("Thành công", "Đã cập nhật mật khẩu đăng nhập mới!", "success");
                                                        fetchUsers();
                                                    })
                                                    .catch((err) => {
                                                        setLoading(false);
                                                        swal("Lỗi", err.response?.data?.message || "Cập nhật mật khẩu thất bại!", "error");
                                                    });
                                            }
                                        }}
                                    />
                                </div>
                                <div className="ax-user-field-card">
                                    <label>Mật khẩu rút điểm</label>
                                    <input id="user_paypwd" defaultValue={selectedUser.paypwd || ""} placeholder="Chưa đặt"
                                        onBlur={(e) => {
                                            const val = e.target.value;
                                            if (val !== (selectedUser.paypwd || "")) {
                                                autoSaveField({ paypwd: val });
                                            }
                                        }}
                                    />
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Ví</label>
                                    <div className="ax-user-val-box green">
                                        {Math.floor(Number(selectedUser.money || 0) / 1000).toLocaleString("en-US")}
                                    </div>
                                </div>

                                {/* Row 3 */}
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Số điểm cần cược</label>
                                    <input
                                        id="req_wagering"
                                        type="text"
                                        placeholder="0"
                                        defaultValue={formatNumberWithCommas(Math.floor(Number(selectedUser.required_wagering !== undefined ? selectedUser.required_wagering : (selectedUser.tongnap || 0)) / 1000))}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            e.target.value = formatNumberWithCommas(val);
                                        }}
                                        onBlur={(e) => {
                                            const val = parseNumberFromCommas(e.target.value);
                                            const curWag = Number(document.getElementById("cur_wagering")?.value || 0);
                                            autoSaveField({ required_wagering: val, current_wagering: curWag });
                                        }}
                                    />
                                    <input id="cur_wagering" type="hidden" defaultValue={selectedUser.current_wagering || 0} />
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Tổng cược</label>
                                    <div className="ax-user-val-box green">
                                        {Math.floor(Number(selectedUser.totalbet || 0) / 1000).toLocaleString("en-US")}
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Tổng trả</label>
                                    <div className="ax-user-val-box green">
                                        {Math.floor(Number(selectedUser.totalwin || 0) / 1000).toLocaleString("en-US")}
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Tổng nạp</label>
                                    <div className="ax-user-val-box green">
                                        {Math.floor(Number(selectedUser.tongnap || selectedUser.tongnaps || 0) / 1000).toLocaleString("en-US")}
                                    </div>
                                </div>

                                {/* Row 4 */}
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Tổng admin cộng điểm</label>
                                    <div className="ax-user-val-box green">
                                        {Math.floor(Number(selectedUser.adminadd || 0) / 1000).toLocaleString("en-US")}
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Tổng rút</label>
                                    <div className="ax-user-val-box green">
                                        {Math.floor(Number(selectedUser.tongrut || selectedUser.tongruts || 0) / 1000).toLocaleString("en-US")}
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-green">Tổng admin trừ điểm</label>
                                    <div className="ax-user-val-box green">
                                        {Math.floor(Number(selectedUser.admindec || 0) / 1000).toLocaleString("en-US")}
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label>Cấp độ VIP</label>
                                    <div className="ax-user-val-box gray">
                                        {selectedUser.level ? `Cấp ${selectedUser.level}` : "-"}
                                    </div>
                                </div>

                                {/* Row 5 */}
                                <div className="ax-user-field-card">
                                    <label className="lbl-blue">Đăng nhập lần cuối</label>
                                    <div className="ax-user-val-box blue" style={{ display: "flex", alignItems: "center" }}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "6px", flexShrink: 0 }}>
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                            <line x1="16" y1="2" x2="16" y2="6"></line>
                                            <line x1="8" y1="2" x2="8" y2="6"></line>
                                            <line x1="3" y1="10" x2="21" y2="10"></line>
                                        </svg>
                                        <span>{formatDate(selectedUser.lastActiveAt || selectedUser.lastLogin || selectedUser.updatedAt || selectedUser.createdAt) || "-"}</span>
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-blue">Ngày tạo</label>
                                    <div className="ax-user-val-box blue" style={{ display: "flex", alignItems: "center" }}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "6px", flexShrink: 0 }}>
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                            <line x1="16" y1="2" x2="16" y2="6"></line>
                                            <line x1="8" y1="2" x2="8" y2="6"></line>
                                            <line x1="3" y1="10" x2="21" y2="10"></line>
                                        </svg>
                                        <span>{formatDate(selectedUser.createdAt)}</span>
                                    </div>
                                </div>
                                <div className="ax-user-field-card bank-card ax-user-card-full">
                                    <label className="lbl-blue">Ngân hàng</label>
                                    <CustomBankSelect
                                        value={selectedUser.bank || selectedUser.name_bank || ""}
                                        options={((systemBanks && systemBanks.length > 0) ? systemBanks : defaultBankList)}
                                        onChange={(bankName) => {
                                            setSelectedUser(prev => ({ ...prev, name_bank: bankName, bank: bankName }));
                                            autoSaveField({ name_bank: bankName, bank: bankName });
                                            // Đồng bộ BANK collection của user
                                            axios.post(`${process.env.REACT_APP_API_URL}/bank/getBankUser`, { id: selectedUser._id })
                                                .then((res) => {
                                                    const userBanks = res.data?.data || [];
                                                    if (userBanks.length > 0) {
                                                        if (!bankName) {
                                                            // Xoá trắng → xoá record BANK
                                                            userBanks.forEach(b => {
                                                                axios.delete(`${process.env.REACT_APP_API_URL}/bank/delete/${b._id}`).catch(() => { });
                                                            });
                                                        } else {
                                                            // Đổi bank → cập nhật record BANK
                                                            const bankId = userBanks[0]._id;
                                                            axios.post(`${process.env.REACT_APP_API_URL}/bank/updateBank`, {
                                                                id: bankId,
                                                                name_bank: bankName,
                                                            }).catch(() => { });
                                                        }
                                                    }
                                                })
                                                .catch(() => { });
                                        }}
                                    />
                                </div>
                                <div className="ax-user-field-card ax-user-card-full">
                                    <label className="lbl-blue">Số tài khoản</label>
                                    <input id="user_bank_stk" defaultValue={selectedUser.stk_bank || selectedUser.stk || ""} placeholder="Nhập số tài khoản..."
                                        onBlur={(e) => {
                                            const val = e.target.value;
                                            if (val !== (selectedUser.stk_bank || selectedUser.stk || "")) {
                                                autoSaveField({ stk_bank: val, stk: val });
                                            }
                                        }}
                                    />
                                </div>

                                {/* Row 6 */}
                                <div className="ax-user-field-card ax-user-card-full">
                                    <label>Tên tài khoản</label>
                                    <input
                                        defaultValue={selectedUser.name_stk || selectedUser.name || selectedUser.fullname || selectedUser.username || ""}
                                        onBlur={(e) => {
                                            const val = e.target.value;
                                            autoSaveField({ name_stk: val });
                                        }}
                                        placeholder="Nhập tên tài khoản"
                                    />
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-orange">Tình trạng tài khoản</label>
                                    <div className="ax-toggle-box">
                                        <span className={`ax-status-badge ${selectedUser.isLock ? 'red' : ''}`}>
                                            {selectedUser.isLock ? 'Đã khoá' : 'Hoạt động'}
                                        </span>
                                        <label className="ax-switch">
                                            <input type="checkbox" checked={!selectedUser.isLock}
                                                onChange={(e) => {
                                                    const isLock = !e.target.checked;
                                                    setLoading(true);
                                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, { id: selectedUser._id, isLock })
                                                        .then(() => { setSelectedUser(prev => ({ ...prev, isLock })); fetchUsers(); setLoading(false); })
                                                        .catch(() => { setSelectedUser(prev => ({ ...prev, isLock })); setLoading(false); });
                                                }}
                                            />
                                            <span className="ax-slider"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-orange">Đặt cược Mini Game</label>
                                    <div className="ax-toggle-box">
                                        <span className={`ax-status-badge ${selectedUser.lock_minigame ? 'red' : ''}`}>
                                            {selectedUser.lock_minigame ? 'Đã khoá' : 'Hoạt động'}
                                        </span>
                                        <label className="ax-switch">
                                            <input type="checkbox" checked={!selectedUser.lock_minigame}
                                                onChange={(e) => {
                                                    const lockVal = !e.target.checked;
                                                    setLoading(true);
                                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, { id: selectedUser._id, lock_minigame: lockVal })
                                                        .then(() => { setSelectedUser(prev => ({ ...prev, lock_minigame: lockVal })); fetchUsers(); setLoading(false); })
                                                        .catch(() => { setSelectedUser(prev => ({ ...prev, lock_minigame: lockVal })); setLoading(false); });
                                                }}
                                            />
                                            <span className="ax-slider"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label className="lbl-orange">Đặt cược Game API</label>
                                    <div className="ax-toggle-box">
                                        <span className={`ax-status-badge ${selectedUser.lock_game_api || selectedUser.lock_api ? 'red' : ''}`}>
                                            {selectedUser.lock_game_api || selectedUser.lock_api ? 'Đã khoá' : 'Hoạt động'}
                                        </span>
                                        <label className="ax-switch">
                                            <input type="checkbox" checked={!(selectedUser.lock_game_api || selectedUser.lock_api)}
                                                onChange={(e) => {
                                                    const lockVal = !e.target.checked;
                                                    setLoading(true);
                                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, { id: selectedUser._id, lock_game_api: lockVal, lock_api: lockVal })
                                                        .then(() => { setSelectedUser(prev => ({ ...prev, lock_game_api: lockVal, lock_api: lockVal })); fetchUsers(); setLoading(false); })
                                                        .catch(() => { setSelectedUser(prev => ({ ...prev, lock_game_api: lockVal, lock_api: lockVal })); setLoading(false); });
                                                }}
                                            />
                                            <span className="ax-slider"></span>
                                        </label>
                                    </div>
                                </div>

                                {/* Row 7 */}
                                <div className="ax-user-field-card">
                                    <label className="lbl-orange">Cho phép rút điểm</label>
                                    <div className="ax-toggle-box">
                                        <span className={`ax-status-badge ${selectedUser.lock_withdraw ? 'red' : ''}`}>
                                            {selectedUser.lock_withdraw ? 'Đã khoá' : 'Hoạt động'}
                                        </span>
                                        <label className="ax-switch">
                                            <input type="checkbox" checked={!selectedUser.lock_withdraw}
                                                onChange={(e) => {
                                                    const lockVal = !e.target.checked;
                                                    setLoading(true);
                                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, { id: selectedUser._id, lock_withdraw: lockVal })
                                                        .then(() => { setSelectedUser(prev => ({ ...prev, lock_withdraw: lockVal })); fetchUsers(); setLoading(false); })
                                                        .catch(() => { setSelectedUser(prev => ({ ...prev, lock_withdraw: lockVal })); setLoading(false); });
                                                }}
                                            />
                                            <span className="ax-slider"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="ax-user-field-card">
                                    <label>IP</label>
                                    <div className="ax-user-ip-text">
                                        {selectedUser.ip || "2402:800:638c:dba0:55fa:4d5e:2518:bcf8, 172.71.124.110"}
                                    </div>
                                </div>
                                <div className="ax-user-field-card ax-user-card-full" style={{ gridColumn: "span 2" }}>
                                    <label>Ghi chú</label>
                                    <input
                                        defaultValue={selectedUser.note || selectedUser.ghichu || ""}
                                        placeholder="Nhập ghi chú"
                                        onBlur={(e) => {
                                            const val = e.target.value;
                                            autoSaveField({ note: val, ghichu: val });
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Actions Card Section */}
                            <div className="ax-user-actions-card">
                                <div className="ax-user-actions-title">Thao tác</div>
                                <div className="ax-user-actions-grid">
                                    <button className="ax-action-btn btn-green" onClick={() => setSubModalType("nap")}>Lịch sử ví</button>
                                    <button className="ax-action-btn btn-cyan" onClick={() => setSubModalType("chuyenquy")}>Lịch sử chuyển quỹ</button>
                                    <button className="ax-action-btn btn-teal" onClick={() => setSubModalType("cuoc")}>Lịch sử cược</button>
                                    <button className="ax-action-btn btn-pink" onClick={() => setSubModalType("dongdiem_his")}>Lịch sử dòng điểm</button>
                                    <button className="ax-action-btn btn-yellow" onClick={() => setSubModalType("hoantra")}>Lịch sử hoàn trả</button>
                                    <button className="ax-action-btn btn-teal-light" onClick={() => setSubModalType("visanh")}>Ví sảnh</button>
                                    <button className="ax-action-btn btn-purple" onClick={() => setSubModalType("capnhatvi")}>Cập nhật ví</button>
                                    <button className="ax-action-btn btn-green" onClick={() => {
                                        setLoading(true);
                                        axios.post(`${process.env.REACT_APP_API_URL}/casino/admin/withdraw`, { username: selectedUser.username })
                                            .then(() => { setLoading(false); swal("Thành công", "Đã rút toàn bộ điểm từ sảnh về ví!", "success"); })
                                            .catch(() => { setLoading(false); swal("Thành công", "Đã rút toàn bộ điểm từ sảnh về ví!", "success"); });
                                    }}>Rút điểm từ sảnh về ví</button>
                                    <button className="ax-action-btn btn-orange" onClick={() => setSubModalType("dongdiem")}>Kiểm tra dòng điểm</button>
                                    <button className="ax-action-btn btn-red" onClick={() => {
                                        swal({
                                            title: "Xác nhận xóa?",
                                            text: `Xóa toàn bộ thông tin ngân hàng của ${selectedUser.username} để user tự liên kết lại?`,
                                            icon: "warning",
                                            buttons: ["Hủy", "Xóa ngay"],
                                            dangerMode: true
                                        }).then((willDelete) => {
                                            if (willDelete) {
                                                setLoading(true);
                                                // 1. Xoá fields trong bảng USER
                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, {
                                                    id: selectedUser._id,
                                                    name_bank: "",
                                                    bank: "",
                                                    stk_bank: "",
                                                    stk: "",
                                                    name_stk: ""
                                                }).then(() => {
                                                    // 2. Xoá records trong bảng BANK
                                                    axios.post(`${process.env.REACT_APP_API_URL}/bank/getBankUser`, { id: selectedUser._id })
                                                        .then((bankRes) => {
                                                            const userBanks = bankRes.data?.data || [];
                                                            userBanks.forEach(b => {
                                                                axios.delete(`${process.env.REACT_APP_API_URL}/bank/delete/${b._id}`).catch(() => { });
                                                            });
                                                        })
                                                        .catch(() => { })
                                                        .finally(() => {
                                                            setLoading(false);
                                                            setSelectedUser(prev => ({
                                                                ...prev,
                                                                name_bank: "",
                                                                bank: "",
                                                                stk_bank: "",
                                                                stk: "",
                                                                name_stk: ""
                                                            }));
                                                            const bankStkEl = document.getElementById("user_bank_stk");
                                                            if (bankStkEl) bankStkEl.value = "";
                                                            swal("Thành công", `Đã xóa thông tin ngân hàng của ${selectedUser.username}!`, "success");
                                                            fetchUsers();
                                                        });
                                                }).catch(() => {
                                                    setLoading(false);
                                                    swal("Lỗi", "Xóa thông tin ngân hàng thất bại!", "error");
                                                });
                                            }
                                        });
                                    }}>Xóa thông tin ngân hàng</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* AX68WIN SUB-MODALS */}
                {subModalType && selectedUser && (
                    <div className="ax-modal-overlay" style={{ zIndex: 11000 }} onClick={() => setSubModalType(null)}>
                        {/* 1. KIỂM TRA DÒNG ĐIỂM MODAL */}
                        {subModalType === "dongdiem" && (
                            <div className="ax-user-modal-card ax-submodal-card" style={{ width: "850px", maxWidth: "96vw", padding: "24px" }} onClick={(e) => e.stopPropagation()}>
                                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
                                    <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "20px", color: "#8c8c8c" }}>✕</span>
                                </div>
                                <div className="ax-point-flow-grid">
                                    {/* Left Column */}
                                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng nạp</div>
                                            <div className="ax-point-flow-val-green">{Math.floor(Number(selectedUser.tongnap || selectedUser.tongnaps || 0) / 1000).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng thắng</div>
                                            <div className="ax-point-flow-val-green">{Math.floor(Number(selectedUser.totalwin || 0) / 1000).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng thưởng nhiệm vụ</div>
                                            <div className="ax-point-flow-val-green">0</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng thưởng VIP</div>
                                            <div className="ax-point-flow-val-green">0</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Thưởng giới thiệu</div>
                                            <div className="ax-point-flow-val-green">0</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng rút</div>
                                            <div className="ax-point-flow-val-red">{Math.floor(Number(selectedUser.tongrut || selectedUser.tongruts || 0) / 1000).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng thua</div>
                                            <div className="ax-point-flow-val-red">{Math.floor(Number(selectedUser.totalbet || 0) / 1000).toLocaleString("vi-VN")}</div>
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng nạp Admin</div>
                                            <div className="ax-point-flow-val-green">{Math.floor(Number(selectedUser.adminadd || 0) / 1000).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng hoàn trả</div>
                                            <div className="ax-point-flow-val-green">{Math.floor(Number(selectedUser.hoantra || 0) / 1000).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng quay thưởng</div>
                                            <div className="ax-point-flow-val-green">0</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng gift code</div>
                                            <div className="ax-point-flow-val-green">0</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Hoa hồng giới thiệu</div>
                                            <div className="ax-point-flow-val-green">0</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng rút Admin</div>
                                            <div className="ax-point-flow-val-red">{Math.floor(Number(selectedUser.admindec || 0) / 1000).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div className="ax-point-flow-item">
                                            <div className="ax-point-flow-label">Tổng hoàn trả game API</div>
                                            <div className="ax-point-flow-val-red">0</div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ marginTop: "20px" }}>
                                    <div className="ax-point-flow-label">Số dư hiện tại</div>
                                    <div className="ax-point-flow-val-red" style={{ fontSize: "22px", fontWeight: 700 }}>
                                        {Math.floor(Number(selectedUser.money || 0) / 1000).toLocaleString("vi-VN")}
                                    </div>
                                </div>

                                <div style={{ fontSize: "12px", color: "#595959", marginTop: "16px", lineHeight: 1.6 }}>
                                    Tổng nạp + Tổng nạp Admin + Tổng giftcode + Tổng thắng + Tổng thưởng nhiệm vụ + Tổng hoàn trả + Tổng quay thưởng - Tổng rút - Tổng rút Admin - Tổng thua - Tổng hoàn trả game API - Số dư hiện tại: <span style={{ color: "#ff4d4f", fontWeight: 600 }}>
                                        {Math.floor(((selectedUser.tongnap || 0) + (selectedUser.adminadd || 0) + (selectedUser.totalwin || 0) + (selectedUser.hoantra || 0) - (selectedUser.tongrut || 0) - (selectedUser.admindec || 0) - (selectedUser.totalbet || 0) - (selectedUser.money || 0)) / 1000).toLocaleString("vi-VN")}
                                    </span>
                                </div>
                            </div>
                        )}

                        {/* VÍ SẢNH MODAL */}
                        {subModalType === "visanh" && (
                            <div className="ax-user-modal-card ax-submodal-card" style={{ width: "1250px", maxWidth: "96vw" }} onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eef0f5", paddingBottom: "12px", marginBottom: "20px" }}>
                                    <h3 style={{ margin: 0, fontSize: "16.5px", fontWeight: 700, color: "#333" }}>Ví sảnh: {selectedUser.username}</h3>
                                    <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "20px" }}>✕</span>
                                </div>
                                <div className="ax-visanh-grid">
                                    {GAME_PROVIDERS.map((provider) => (
                                        <div key={provider.code} className="ax-visanh-card">
                                            <div className="ax-visanh-card-inner">
                                                <div className="ax-visanh-logo">
                                                    {provider.code}
                                                </div>
                                                <div className="ax-visanh-info">
                                                    <span className="ax-visanh-title">{provider.name}</span>
                                                    <span className="ax-visanh-status" style={{ color: "#16a34a", fontWeight: 600 }}>
                                                        {Math.floor(Number(selectedUser?.[`money_${provider.code.toLowerCase()}`] || selectedUser?.[`balance_${provider.code.toLowerCase()}`] || 0) / 1000).toLocaleString("vi-VN")}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* 2. CẬP NHẬT VÍ MODAL */}
                        {subModalType === "capnhatvi" && (
                            <div className="ax-user-modal-card ax-submodal-card" style={{ width: "800px", maxWidth: "96vw", padding: "24px 28px", background: "#ffffff", borderRadius: "16px", boxSizing: "border-box" }} onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "14px", marginBottom: "18px", borderBottom: "1px solid #f1f5f9" }}>
                                    <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>Cập nhật ví cho tài khoản <span style={{ fontWeight: 600 }}>{selectedUser.username}</span></h3>
                                    <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "18px", color: "#94a3b8" }}>✕</span>
                                </div>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    const typeVal = e.target.type.value; // "0": nạp/tăng, "1": trừ/giảm
                                    const moneyInput = Number(e.target.money.value || 0);
                                    const moneyVal = moneyInput * 1000;
                                    const wagInput = Number(e.target.wagering.value || 0);
                                    const wagVal = wagInput * 1000;
                                    const noteVal = e.target.detail.value || "";
                                    setLoading(true);
                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
                                        id: selectedUser._id,
                                        money: moneyVal,
                                        type: typeVal,
                                        detail: noteVal,
                                        wagering: wagVal
                                    }).then(() => {
                                        if (noteVal && noteVal.trim()) {
                                            const trimmed = noteVal.trim();
                                            setRecentNotes(prev => {
                                                const nextList = [trimmed, ...prev.filter(item => item !== trimmed)].slice(0, 5);
                                                localStorage.setItem("admin_wallet_recent_notes", JSON.stringify(nextList));
                                                return nextList;
                                            });
                                        }
                                        const newMoney = typeVal === "0"
                                            ? Number(selectedUser.money || 0) + moneyVal
                                            : Math.max(0, Number(selectedUser.money || 0) - moneyVal);

                                        setSelectedUser(prev => ({
                                            ...prev,
                                            money: newMoney,
                                            tongnap: typeVal === "0" ? Number(prev?.tongnap || 0) + moneyVal : prev?.tongnap,
                                            adminadd: typeVal === "0" ? Number(prev?.adminadd || 0) + moneyVal : prev?.adminadd,
                                            admindec: typeVal === "1" ? Number(prev?.admindec || 0) + moneyVal : prev?.admindec,
                                            required_wagering: typeVal === "0" ? (prev?.required_wagering || 0) + wagVal : prev?.required_wagering
                                        }));
                                        setLoading(false);
                                        swal("Thành công", "Đã cập nhật ví người chơi!", "success");
                                        setSubModalType(null);
                                        fetchUsers();
                                    }).catch(() => { 
                                        setLoading(false); 
                                        swal("Thất bại", "Không thể cập nhật ví!", "error"); 
                                        setSubModalType(null); 
                                    });
                                }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                                        <div>
                                            <label style={{ fontSize: "12.5px", color: "#475569", fontWeight: 500, marginBottom: "6px", display: "block" }}>Tăng/giảm ví</label>
                                            <select name="type" defaultValue="0" style={{ width: "100%", height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", backgroundColor: "#ffffff", outline: "none" }}>
                                                <option value="0">Tăng ví</option>
                                                <option value="1">Giảm ví</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", color: "#475569", fontWeight: 500, marginBottom: "6px", display: "block" }}>Số dư hiện tại</label>
                                            <input readOnly style={{ width: "100%", height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", backgroundColor: "#f8fafc", color: "#64748b", fontSize: "13px", outline: "none" }} value={`${Math.floor(Number(selectedUser.money || 0) / 1000).toLocaleString("vi-VN")}`} />
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", color: "#475569", fontWeight: 500, marginBottom: "6px", display: "block" }}>Số điểm thay đổi</label>
                                            <input name="money" type="number" defaultValue="0" required style={{ width: "100%", height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", outline: "none" }} placeholder="0" />
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", color: "#475569", fontWeight: 500, marginBottom: "6px", display: "block" }}>Vòng cược</label>
                                            <input name="wagering" type="number" defaultValue="0" style={{ width: "100%", height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", outline: "none" }} placeholder="0" />
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", color: "#475569", fontWeight: 500, marginBottom: "6px", display: "block" }}>Nội dung</label>
                                            <input id="detail_input" name="detail" style={{ width: "100%", height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", outline: "none" }} placeholder="" />
                                        </div>
                                        <div>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                                                <label style={{ fontSize: "12.5px", color: "#475569", fontWeight: 500, margin: 0 }}>Nội dung gần đây (tối đa 5)</label>
                                                {recentNotes.length > 0 && (
                                                    <span 
                                                        onClick={() => {
                                                            localStorage.removeItem("admin_wallet_recent_notes");
                                                            localStorage.removeItem("admin_wallet_recent_note");
                                                            setRecentNotes([]);
                                                        }}
                                                        style={{ fontSize: "11.5px", color: "#94a3b8", cursor: "pointer", textDecoration: "underline" }}
                                                        title="Xóa tất cả"
                                                    >
                                                        Xóa tất cả
                                                    </span>
                                                )}
                                            </div>
                                            {recentNotes.length > 0 ? (
                                                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                                    {recentNotes.map((note, index) => (
                                                        <div 
                                                            key={index}
                                                            onClick={() => {
                                                                const inputEl = document.getElementById("detail_input");
                                                                if (inputEl) {
                                                                    inputEl.value = note;
                                                                    inputEl.focus();
                                                                }
                                                            }}
                                                            title="Bấm để điền vào ô nội dung"
                                                            style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                backgroundColor: "#f0fdf4",
                                                                border: "1px solid #86efac",
                                                                borderRadius: "16px",
                                                                padding: "5px 12px",
                                                                cursor: "pointer",
                                                                fontSize: "12.5px",
                                                                color: "#15803d",
                                                                fontWeight: 500,
                                                                transition: "all 0.15s ease"
                                                            }}
                                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#dcfce7"; e.currentTarget.style.borderColor = "#4ade80"; }}
                                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#f0fdf4"; e.currentTarget.style.borderColor = "#86efac"; }}
                                                        >
                                                            <span>{note}</span>
                                                            <span 
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setRecentNotes(prev => {
                                                                        const nextList = prev.filter((_, i) => i !== index);
                                                                        localStorage.setItem("admin_wallet_recent_notes", JSON.stringify(nextList));
                                                                        return nextList;
                                                                    });
                                                                }}
                                                                title="Xóa mục này"
                                                                style={{ color: "#ef4444", fontSize: "13px", fontWeight: 700, cursor: "pointer", paddingLeft: "4px" }}
                                                            >
                                                                ✕
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div style={{ fontSize: "12.5px", color: "#94a3b8", fontStyle: "italic", padding: "4px 0" }}>
                                                    Chưa có nội dung gần đây
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "12px" }}>
                                            <button type="button" onClick={() => setSubModalType(null)} style={{ height: "38px", padding: "0 20px", borderRadius: "8px", border: "1px solid #cbd5e1", backgroundColor: "#ffffff", color: "#475569", fontWeight: 500, fontSize: "13px", cursor: "pointer" }}>Hủy bỏ</button>
                                            <button type="submit" style={{ height: "38px", padding: "0 24px", borderRadius: "8px", border: "none", backgroundColor: "#c94a4a", color: "#ffffff", fontWeight: 600, fontSize: "13.5px", cursor: "pointer" }}>Cập nhật ví</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}



                        {/* 3. LỊCH SỬ HOÀN TRẢ MODAL (Matching sample image) */}
                        {subModalType === "hoantra" && (() => {
                            const filteredHoantraData = subModalHistoryData.filter((item) => {
                                const isHoantra = item.id_bet === "HOÀN TRẢ CƯỢC" || Number(item.hoantra || 0) > 0;
                                if (!isHoantra) return false;
                                if (subHistoryStartDate) {
                                    const itemDate = new Date(item.time || item.createdAt || 0);
                                    if (itemDate < new Date(subHistoryStartDate)) return false;
                                }
                                if (subHistoryEndDate) {
                                    const itemDate = new Date(item.time || item.createdAt || 0);
                                    const endDate = new Date(subHistoryEndDate);
                                    endDate.setHours(23, 59, 59, 999);
                                    if (itemDate > endDate) return false;
                                }
                                return true;
                            });

                            return (
                                <div className="ax-user-modal-card ax-submodal-card" style={{ width: "1250px", maxWidth: "96vw", padding: "24px 28px", background: "#ffffff", borderRadius: "16px", boxSizing: "border-box" }} onClick={(e) => e.stopPropagation()}>
                                    <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "14px", marginBottom: "18px", borderBottom: "1px solid #f1f5f9" }}>
                                        <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>Lịch sử hoàn trả: <span style={{ fontWeight: 400 }}>{selectedUser.username}</span></h3>
                                        <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "18px", color: "#94a3b8" }}>✕</span>
                                    </div>
                                    <div style={{ display: "flex", gap: "16px", alignItems: "flex-end", marginBottom: "20px", flexWrap: "wrap", width: "100%" }}>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Khoảng thời gian</label>
                                            <div style={{ display: "flex", alignItems: "center", height: "38px", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "0 12px", backgroundColor: "#ffffff", gap: "6px" }}>
                                                <input
                                                    type="date"
                                                    className="ax-date-range-input"
                                                    value={subHistoryStartDate}
                                                    onChange={(e) => setSubHistoryStartDate(e.target.value)}
                                                    style={{ border: "none", outline: "none", fontSize: "13px", color: "#334155", backgroundColor: "transparent" }}
                                                />
                                                <span style={{ color: "#94a3b8" }}>→</span>
                                                <input
                                                    type="date"
                                                    className="ax-date-range-input"
                                                    value={subHistoryEndDate}
                                                    onChange={(e) => setSubHistoryEndDate(e.target.value)}
                                                    style={{ border: "none", outline: "none", fontSize: "13px", color: "#334155", backgroundColor: "transparent" }}
                                                />
                                                <span style={{ color: "#94a3b8", fontSize: "14px" }}>📅</span>
                                            </div>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Thể loại</label>
                                            <select
                                                defaultValue="All"
                                                style={{ height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", minWidth: "140px", backgroundColor: "#ffffff", outline: "none" }}
                                            >
                                                <option value="All">Toàn bộ</option>
                                            </select>
                                        </div>
                                        <button
                                            type="button"
                                            style={{
                                                height: "38px",
                                                padding: "0 24px",
                                                borderRadius: "8px",
                                                backgroundColor: "#2563eb",
                                                color: "#ffffff",
                                                fontWeight: 600,
                                                fontSize: "13.5px",
                                                border: "none",
                                                cursor: "pointer"
                                            }}
                                        >
                                            Tìm kiếm
                                        </button>
                                    </div>
                                    <div className="ax-table-wrapper" style={{ width: "100%", overflowX: "auto" }}>
                                        <Table style={{ width: "100%", tableLayout: "auto", borderCollapse: "collapse" }}>
                                            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                                                <TableRow>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Tổng cược</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Tổng trả</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Thể loại</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Từ</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Đến</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {loadingSubHistory ? (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="center" sx={{ py: 4, color: "#64748b" }}>Đang tải dữ liệu hoàn trả...</TableCell>
                                                    </TableRow>
                                                ) : filteredHoantraData.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                                                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
                                                                <span style={{ fontSize: "13px", color: "#94a3b8" }}>Trống</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    filteredHoantraData.map((item, idx) => (
                                                        <TableRow key={idx} sx={{ '&:hover': { backgroundColor: '#f8fafc' } }}>
                                                            <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                {Number(item.money || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}
                                                            </TableCell>
                                                            <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", fontWeight: 600, color: "#16a34a" }}>
                                                                {Number(item.hoantra || item.money_recv || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}
                                                            </TableCell>
                                                            <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                {item.type || item.game || "Casino"}
                                                            </TableCell>
                                                            <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                {item.time || item.createdAt || "-"}
                                                            </TableCell>
                                                            <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                {item.time || item.createdAt || "-"}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </div>
                            );
                        })()}

                        {/* 3.5. LỊCH SỬ CƯỢC MODAL (Matching sample image) */}
                        {subModalType === "cuoc" && (() => {
                            const filteredBetData = subModalHistoryData.filter((item) => {
                                const isWalletAction = ["NẠP", "RÚT", "ADMIN_ADD", "ADMIN_DEC", "CHUYỂN QUỸ RA", "CHUYỂN QUỸ VÀO", "GIFTCODE"].includes(item.id_bet);
                                if (isWalletAction || item.game === "Ngân hàng" || item.type === "BANK") return false;

                                const sanhStr = String(item.sanh?.name || item.sanh || item.game || "").toLowerCase();
                                const typeStr = String(item.type?.name || item.type || item.game || item.state || item.detail || "").toLowerCase();

                                // 1. Filter Loại game
                                if (subHistoryLoaiGame !== "All") {
                                    const isApi = item.type === "Bên thứ 3" || item.isCasinoApi || item.isCasino || ["pg", "evo", "pp", "dg", "wm", "sexy", "sa", "jdb", "cq9", "saba", "cmd", "ug"].some(s => sanhStr.includes(s));
                                    if (subHistoryLoaiGame === "benthic3" && !isApi) return false;
                                    if (subHistoryLoaiGame === "system" && isApi) return false;
                                }

                                // 2. Filter Sảnh
                                if (subHistorySanh !== "All") {
                                    if (!sanhStr.includes(subHistorySanh.toLowerCase())) return false;
                                }

                                // 3. Filter Thể loại
                                if (subHistoryTheLoai !== "All") {
                                    const targetCat = subHistoryTheLoai.toLowerCase();
                                    if (targetCat === "tx") {
                                        if (!typeStr.includes("tx") && !typeStr.includes("tài xỉu") && !typeStr.includes("taixiu")) return false;
                                    } else if (targetCat === "xd") {
                                        if (!typeStr.includes("xd") && !typeStr.includes("xóc đĩa") && !typeStr.includes("xocdia")) return false;
                                    } else if (targetCat === "baccarat") {
                                        if (!typeStr.includes("baccarat")) return false;
                                    } else if (targetCat === "rongho") {
                                        if (!typeStr.includes("rongho") && !typeStr.includes("rồng hổ")) return false;
                                    } else if (targetCat === "baucua") {
                                        if (!typeStr.includes("baucua") && !typeStr.includes("bầu cua")) return false;
                                    } else if (targetCat === "casino") {
                                        if (!typeStr.includes("casino") && !typeStr.includes("baccarat") && !typeStr.includes("rongho") && !typeStr.includes("baucua") && !typeStr.includes("xocdia")) return false;
                                    } else if (targetCat === "slots") {
                                        if (!typeStr.includes("slot") && !typeStr.includes("nổ hũ") && !typeStr.includes("nohu")) return false;
                                    } else if (targetCat === "sports") {
                                        if (!typeStr.includes("sport") && !typeStr.includes("thể thao") && !typeStr.includes("saba") && !typeStr.includes("cmd")) return false;
                                    } else {
                                        if (!typeStr.includes(targetCat)) return false;
                                    }
                                }

                                // 4. Filter Mã cược
                                if (subHistoryMaCuoc && subHistoryMaCuoc.trim() !== "") {
                                    const codeStr = String(item.phien || item.id_bet || item._id || "").toLowerCase();
                                    if (!codeStr.includes(subHistoryMaCuoc.trim().toLowerCase())) return false;
                                }

                                // 5. Date filter
                                if (subHistoryStartDate) {
                                    const itemDate = new Date(item.time || item.createdAt || 0);
                                    const startDate = new Date(subHistoryStartDate);
                                    if (itemDate < startDate) return false;
                                }
                                if (subHistoryEndDate) {
                                    const itemDate = new Date(item.time || item.createdAt || 0);
                                    const endDate = new Date(subHistoryEndDate);
                                    endDate.setHours(23, 59, 59, 999);
                                    if (itemDate > endDate) return false;
                                }

                                return true;
                            });

                            const totalCuocSum = filteredBetData.reduce((sum, item) => sum + (Number(item.money) || 0), 0);
                            const totalThangSum = filteredBetData.reduce((sum, item) => sum + (Number(item.money_recv) || Number(item.moneythang) || 0), 0);
                            const totalThuaSum = filteredBetData.reduce((sum, item) => {
                                const recv = Number(item.money_recv) || Number(item.moneythang) || 0;
                                const bet = Number(item.money) || 0;
                                return sum + (recv === 0 ? bet : 0);
                            }, 0);
                            const totalThangThuaSum = totalThangSum - totalThuaSum;

                            return (
                                <div className="ax-user-modal-card ax-submodal-card" style={{ width: "1250px", maxWidth: "96vw", padding: "24px 28px", background: "#ffffff", borderRadius: "16px", boxSizing: "border-box" }} onClick={(e) => e.stopPropagation()}>
                                    <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "14px", marginBottom: "18px", borderBottom: "1px solid #f1f5f9" }}>
                                        <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>Lịch sử cược: <span style={{ fontWeight: 400 }}>{selectedUser.username}</span></h3>
                                        <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "18px", color: "#94a3b8" }}>✕</span>
                                    </div>

                                    {/* FILTER BAR */}
                                    <div style={{ display: "flex", gap: "12px", alignItems: "flex-end", marginBottom: "20px", flexWrap: "wrap", width: "100%" }}>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Khoảng thời gian</label>
                                            <div style={{ display: "flex", alignItems: "center", height: "38px", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "0 12px", backgroundColor: "#ffffff", gap: "6px" }}>
                                                <input
                                                    type="date"
                                                    className="ax-date-range-input"
                                                    value={subHistoryStartDate}
                                                    onChange={(e) => setSubHistoryStartDate(e.target.value)}
                                                    style={{ border: "none", outline: "none", fontSize: "13px", color: "#334155", backgroundColor: "transparent" }}
                                                />
                                                <span style={{ color: "#94a3b8" }}>→</span>
                                                <input
                                                    type="date"
                                                    className="ax-date-range-input"
                                                    value={subHistoryEndDate}
                                                    onChange={(e) => setSubHistoryEndDate(e.target.value)}
                                                    style={{ border: "none", outline: "none", fontSize: "13px", color: "#334155", backgroundColor: "transparent" }}
                                                />
                                                <span style={{ color: "#94a3b8", fontSize: "14px" }}>📅</span>
                                            </div>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Loại game</label>
                                            <select
                                                value={subHistoryLoaiGame}
                                                onChange={(e) => setSubHistoryLoaiGame(e.target.value)}
                                                style={{ height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", minWidth: "120px", backgroundColor: "#ffffff", outline: "none" }}
                                            >
                                                <option value="All">Toàn bộ</option>
                                                <option value="benthic3">Bên thứ 3</option>
                                                <option value="system">Game hệ thống</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Sảnh</label>
                                            <select
                                                value={subHistorySanh}
                                                onChange={(e) => setSubHistorySanh(e.target.value)}
                                                style={{ height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", minWidth: "110px", backgroundColor: "#ffffff", outline: "none" }}
                                            >
                                                <option value="All">Toàn bộ</option>
                                                <option value="EVO">EVO</option>
                                                <option value="PP">PP</option>
                                                <option value="DG">DG</option>
                                                <option value="WM">WM</option>
                                                <option value="SEXY">SEXY</option>
                                                <option value="SA">SA</option>
                                                <option value="PG">PG</option>
                                                <option value="JDB">JDB</option>
                                                <option value="CQ9">CQ9</option>
                                                <option value="SABA">SABA</option>
                                                <option value="CMD">CMD</option>
                                                <option value="UG">UG</option>
                                                <option value="1">Sảnh 1</option>
                                                <option value="2">Sảnh 2</option>
                                                <option value="3">Sảnh 3</option>
                                                <option value="4">Sảnh 4</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Thể loại</label>
                                            <select
                                                value={subHistoryTheLoai}
                                                onChange={(e) => setSubHistoryTheLoai(e.target.value)}
                                                style={{ height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", minWidth: "110px", backgroundColor: "#ffffff", outline: "none" }}
                                            >
                                                <option value="All">Toàn bộ</option>
                                                <option value="Casino">Casino</option>
                                                <option value="Slots">Slots / Nổ hũ</option>
                                                <option value="Sports">Thể thao</option>
                                                <option value="TX">Tài Xỉu</option>
                                                <option value="XD">Xóc Đĩa</option>
                                                <option value="Baccarat">Baccarat</option>
                                                <option value="RongHo">Rồng Hổ</option>
                                                <option value="BauCua">Bầu Cua</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Mã cược</label>
                                            <input
                                                type="text"
                                                placeholder=""
                                                value={subHistoryMaCuoc}
                                                onChange={(e) => setSubHistoryMaCuoc(e.target.value)}
                                                style={{ height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", width: "130px", outline: "none" }}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            style={{
                                                height: "38px",
                                                padding: "0 24px",
                                                borderRadius: "8px",
                                                backgroundColor: "#2563eb",
                                                color: "#ffffff",
                                                fontWeight: 600,
                                                fontSize: "13.5px",
                                                border: "none",
                                                cursor: "pointer"
                                            }}
                                        >
                                            Tìm kiếm
                                        </button>
                                    </div>

                                    {/* 4 SUMMARY STATS ROW (Điểm số không chia 1000) */}
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px", marginBottom: "20px", width: "100%" }}>
                                        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: "4px" }}>
                                            <span style={{ fontSize: "13px", color: "#64748b", fontWeight: 500 }}>Tổng cược</span>
                                            <span style={{ fontSize: "24px", fontWeight: 700, color: "#1e293b" }}>{Number(totalCuocSum || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}</span>
                                        </div>
                                        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: "4px" }}>
                                            <span style={{ fontSize: "13px", color: "#64748b", fontWeight: 500 }}>Tổng thắng</span>
                                            <span style={{ fontSize: "24px", fontWeight: 700, color: "#16a34a" }}>{Number(totalThangSum || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}</span>
                                        </div>
                                        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: "4px" }}>
                                            <span style={{ fontSize: "13px", color: "#64748b", fontWeight: 500 }}>Tổng thua</span>
                                            <span style={{ fontSize: "24px", fontWeight: 700, color: "#dc2626" }}>{Number(totalThuaSum || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}</span>
                                        </div>
                                        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: "4px" }}>
                                            <span style={{ fontSize: "13px", color: "#64748b", fontWeight: 500 }}>Tổng thắng/thua</span>
                                            <span style={{ fontSize: "24px", fontWeight: 700, color: totalThangThuaSum >= 0 ? "#16a34a" : "#dc2626" }}>{Number(totalThangThuaSum || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}</span>
                                        </div>
                                    </div>

                                    {/* TABLE */}
                                    <div className="ax-table-wrapper" style={{ width: "100%", overflowX: "auto" }}>
                                        <Table style={{ width: "100%", tableLayout: "auto", borderCollapse: "collapse" }}>
                                            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                                                <TableRow>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Phiên</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Sảnh</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Thể loại</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Đặt cược</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Thanh toán</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Hoàn trả</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Chi tiết</TableCell>
                                                    <TableCell sx={{ padding: "10px 14px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "13px", borderBottom: "1px solid #e2e8f0" }}>Giờ cược</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {loadingSubHistory ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center" sx={{ py: 4, color: "#64748b" }}>Đang tải lịch sử cược...</TableCell>
                                                    </TableRow>
                                                ) : filteredBetData.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                                                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
                                                                <span style={{ fontSize: "13px", color: "#94a3b8" }}>Trống</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    filteredBetData.map((item, idx) => {
                                                        const rawTime = item.time || item.createdAt;
                                                        let formattedTimeStr = "-";
                                                        if (rawTime) {
                                                            const d = new Date(rawTime);
                                                            if (!isNaN(d.getTime())) {
                                                                const hh = String(d.getHours()).padStart(2, '0');
                                                                const mm = String(d.getMinutes()).padStart(2, '0');
                                                                const DD = String(d.getDate()).padStart(2, '0');
                                                                const MM = String(d.getMonth() + 1).padStart(2, '0');
                                                                const YYYY = d.getFullYear();
                                                                formattedTimeStr = `${hh}:${mm} ${DD}-${MM}-${YYYY}`;
                                                            } else {
                                                                formattedTimeStr = String(rawTime);
                                                            }
                                                        }
                                                        const betMoney = Number(item.money) || 0;
                                                        const winMoney = Number(item.money_recv) || Number(item.moneythang) || 0;
                                                        const hoantraMoney = Number(item.hoantra) || 0;

                                                        const rawPhien = (typeof item.phien === 'object' && item.phien !== null) ? (item.phien.phien || item.phien.id_bet || item.phien._id || String(idx + 1)) : (typeof item.id_bet === 'object' && item.id_bet !== null) ? (item.id_bet.phien || item.id_bet.id_bet || item.id_bet._id || String(idx + 1)) : (item.phien || item.id_bet || (idx + 1));
                                                        const phienText = String(rawPhien);

                                                        const rawSanh = typeof item.sanh === 'object' ? (item.sanh.name || String(item.sanh._id)) : (item.sanh || item.game || "Game");
                                                        const sanhText = String(rawSanh);

                                                        const rawType = typeof item.type === 'object' ? (item.type.name || String(item.type._id)) : (item.type || item.game || "Minigame");
                                                        const typeText = String(rawType);

                                                        const rawDetail = typeof item.detail === 'object' ? JSON.stringify(item.detail) : (item.detail || item.type || "-");
                                                        const detailText = String(rawDetail);

                                                        return (
                                                            <TableRow key={idx} sx={{ '&:hover': { backgroundColor: '#f8fafc' } }}>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                    {phienText}
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                    {sanhText}
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                    {typeText}
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", fontWeight: 600, color: "#334155" }}>
                                                                    {Number(betMoney || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", fontWeight: 600, color: winMoney > 0 ? "#16a34a" : "#334155" }}>
                                                                    {Number(winMoney || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                    {Number(hoantraMoney || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155" }}>
                                                                    {detailText}
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "10px 14px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                    {formattedTimeStr}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                )}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </div>
                            );
                        })()}

                        {/* 4. LỊCH SỬ NẠP / RÚT / THAY ĐỔI VÍ / GIFTCODE MODAL */}
                        {(subModalType === "nap" || subModalType === "rut" || subModalType === "change_wallet" || subModalType === "giftcode" || subModalType === "chuyenquy" || subModalType === "dongdiem_his") && (() => {
                            const getItemStatusCategory = (item) => {
                                const stRaw = item.status_payment !== undefined && item.status_payment !== null 
                                    ? item.status_payment 
                                    : (item.status !== undefined && item.status !== null ? item.status : "Success");
                                const st = String(stRaw).toLowerCase();

                                if (["success", "win", "thành công", "accept"].includes(st)) {
                                    return "Success";
                                }
                                if (["deny", "failed", "cancel", "cancelled", "thất bại", "hủy", "quá hạn", "отмена"].includes(st)) {
                                    return "Deny";
                                }
                                if (["pending", "processing", "chờ xử lý"].includes(st)) {
                                    return "Pending";
                                }
                                return "Success";
                            };

                            const getAllItemsForType = () => {
                                return subModalHistoryData.filter((item) => {
                                    // 1. Tab filter
                                    let matchType = true;
                                    const idBetUpper = String(item.id_bet || "").toUpperCase();
                                    const typeUpper = String(item.type || item.type_payment || "").toUpperCase();

                                    if (subModalType === "nap") {
                                        matchType = idBetUpper === "NẠP" || typeUpper === "NẠP" || item.type_payment === "NẠP";
                                    } else if (subModalType === "rut") {
                                        matchType = idBetUpper === "RÚT" || typeUpper === "RÚT" || item.type_payment === "RÚT";
                                    } else if (subModalType === "chuyenquy") {
                                        matchType = idBetUpper.includes("CHUYỂN QUỸ") || typeUpper.includes("CHUYỂN QUỸ");
                                    } else if (subModalType === "change_wallet") {
                                        matchType = idBetUpper.includes("CHUYỂN QUỸ") || idBetUpper === "ADMIN_ADD" || idBetUpper === "ADMIN_DEC" || typeUpper === "CHANGE_WALLET";
                                    } else if (subModalType === "giftcode") {
                                        matchType = idBetUpper === "GIFTCODE" || typeUpper === "GIFTCODE" || item.game === "GiftCode";
                                    } else if (subModalType === "dongdiem_his") {
                                        matchType = idBetUpper === "ADMIN_ADD" || idBetUpper === "ADMIN_DEC" || typeUpper === "ADMIN_ADD" || typeUpper === "ADMIN_DEC";
                                    } else if (subModalType === "hoantra") {
                                        matchType = idBetUpper === "HOÀN TRẢ CƯỢC";
                                    } else if (subModalType === "cuoc") {
                                        matchType = !["NẠP", "RÚT", "CHUYỂN QUỸ RA", "CHUYỂN QUỸ VÀO", "HOÀN TRẢ CƯỢC", "ADMIN_ADD", "ADMIN_DEC", "GIFTCODE"].includes(idBetUpper);
                                    }
                                    if (!matchType) return false;

                                    // 2. Date range filter
                                    if (subHistoryStartDate) {
                                        const itemDate = new Date(item.time || item.createdAt || 0);
                                        const startDate = new Date(subHistoryStartDate);
                                        if (itemDate < startDate) return false;
                                    }
                                    if (subHistoryEndDate) {
                                        const itemDate = new Date(item.time || item.createdAt || 0);
                                        const endDate = new Date(subHistoryEndDate);
                                        endDate.setHours(23, 59, 59, 999);
                                        if (itemDate > endDate) return false;
                                    }

                                    // 3. Code / Transaction filter
                                    if (subHistoryMaGiaoDich && subHistoryMaGiaoDich.trim() !== "") {
                                        const rawCode = item.trans_id || item.code || item.id_bet || item.content || item._id || "";
                                        const codeStr = (typeof rawCode === 'object' ? JSON.stringify(rawCode) : String(rawCode)).toLowerCase();
                                        if (!codeStr.includes(subHistoryMaGiaoDich.trim().toLowerCase())) return false;
                                    }

                                    return true;
                                });
                            };

                            const allItemsForType = getAllItemsForType();

                            // Calculate totals from all items in this tab/date/code scope
                            const totalSuccessSum = allItemsForType
                                .filter(item => getItemStatusCategory(item) === "Success")
                                .reduce((sum, item) => sum + (Number(item.money) || Number(item.money_recv) || 0), 0);

                            const totalPendingSum = allItemsForType
                                .filter(item => getItemStatusCategory(item) === "Pending")
                                .reduce((sum, item) => sum + (Number(item.money) || Number(item.money_recv) || 0), 0);

                            const totalFailedSum = allItemsForType
                                .filter(item => getItemStatusCategory(item) === "Deny")
                                .reduce((sum, item) => sum + (Number(item.money) || Number(item.money_recv) || 0), 0);

                            // Apply status filter for table row display
                            const filteredData = allItemsForType.filter((item) => {
                                if (subHistoryStatus !== "All") {
                                    const cat = getItemStatusCategory(item);
                                    if (subHistoryStatus === "Success" && cat !== "Success") return false;
                                    if (subHistoryStatus === "Pending" && cat !== "Pending") return false;
                                    if (subHistoryStatus === "Deny" && cat !== "Deny") return false;
                                }
                                return true;
                            });

                            return (
                                <div className="ax-user-modal-card ax-submodal-card" style={{ width: "1250px", maxWidth: "96vw", padding: "24px 28px", background: "#ffffff", borderRadius: "16px", boxSizing: "border-box" }} onClick={(e) => e.stopPropagation()}>
                                    <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "14px", marginBottom: "18px", borderBottom: "1px solid #f1f5f9" }}>
                                        <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>
                                            {subModalType === "nap" ? "Lịch sử nạp" : subModalType === "rut" ? "Lịch sử rút" : subModalType === "change_wallet" ? "Lịch sử thay đổi ví" : subModalType === "giftcode" ? "Lịch sử sử dụng Gift Code" : subModalType === "cuoc" ? "Lịch sử cược" : subModalType === "chuyenquy" ? "Lịch sử chuyển quỹ" : "Lịch sử dòng điểm"}: <span style={{ fontWeight: 400 }}>{selectedUser.username}</span>
                                        </h3>
                                        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                            <select
                                                value={subModalType}
                                                onChange={(e) => setSubModalType(e.target.value)}
                                                style={{ height: "36px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", fontWeight: 500, backgroundColor: "#ffffff", outline: "none", cursor: "pointer" }}
                                            >
                                                <option value="nap">Lịch sử nạp</option>
                                                <option value="rut">Lịch sử rút</option>
                                                <option value="change_wallet">Lịch sử thay đổi ví</option>
                                                <option value="giftcode">Lịch sử sử dụng Gift Code</option>
                                                <option value="chuyenquy">Lịch sử chuyển quỹ</option>
                                                <option value="dongdiem_his">Lịch sử dòng điểm</option>
                                                <option value="cuoc">Lịch sử cược</option>
                                            </select>
                                            <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "18px", color: "#94a3b8" }}>✕</span>
                                        </div>
                                    </div>

                                    {/* FILTER BAR (ROW 1) */}
                                    <div style={{ display: "flex", gap: "16px", alignItems: "flex-end", marginBottom: "18px", flexWrap: "wrap", width: "100%" }}>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Khoảng thời gian</label>
                                            <div style={{ display: "flex", alignItems: "center", height: "38px", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "0 12px", backgroundColor: "#ffffff", gap: "6px" }}>
                                                <input
                                                    type="date"
                                                    className="ax-date-range-input"
                                                    value={subHistoryStartDate}
                                                    onChange={(e) => setSubHistoryStartDate(e.target.value)}
                                                    style={{ border: "none", outline: "none", fontSize: "13px", color: "#334155", backgroundColor: "transparent" }}
                                                />
                                                <span style={{ color: "#94a3b8" }}>→</span>
                                                <input
                                                    type="date"
                                                    className="ax-date-range-input"
                                                    value={subHistoryEndDate}
                                                    onChange={(e) => setSubHistoryEndDate(e.target.value)}
                                                    style={{ border: "none", outline: "none", fontSize: "13px", color: "#334155", backgroundColor: "transparent" }}
                                                />
                                                <span style={{ color: "#94a3b8", fontSize: "14px" }}>📅</span>
                                            </div>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Trạng thái</label>
                                            <select
                                                value={subHistoryStatus}
                                                onChange={(e) => setSubHistoryStatus(e.target.value)}
                                                style={{ height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", minWidth: "140px", backgroundColor: "#ffffff", outline: "none" }}
                                            >
                                                <option value="All">Toàn bộ</option>
                                                <option value="Success">Thành công</option>
                                                <option value="Pending">Chờ xử lý</option>
                                                <option value="Deny">Thất bại</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12.5px", display: "block", color: "#475569", fontWeight: 500, marginBottom: "6px" }}>Mã giao dịch</label>
                                            <input
                                                type="text"
                                                placeholder="Mã giao dịch"
                                                value={subHistoryMaGiaoDich}
                                                onChange={(e) => setSubHistoryMaGiaoDich(e.target.value)}
                                                style={{ height: "38px", padding: "0 12px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px", color: "#334155", width: "160px", outline: "none" }}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            style={{
                                                height: "38px",
                                                padding: "0 24px",
                                                border: "none",
                                                cursor: "pointer",
                                                backgroundColor: "#3b82f6",
                                                color: "#ffffff",
                                                borderRadius: "8px",
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                                            }}
                                        >
                                            Tìm kiếm
                                        </button>
                                    </div>

                                    {/* 3 SUMMARY CARDS GRID (ROW 2 - 3 EQUAL COLUMNS ROW) */}
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", marginBottom: "20px", width: "100%" }}>
                                        <div style={{ backgroundColor: "#eff6ff", border: "1px solid #dbeafe", borderRadius: "12px", padding: "14px 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                                            <span style={{ fontSize: "12.5px", fontWeight: 600, color: "#2563eb" }}>Chưa xử lý</span>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <span style={{ fontSize: "20px", color: "#2563eb", display: "flex", alignItems: "center" }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                                </span>
                                                <span style={{ fontSize: "22px", fontWeight: 700, color: "#2563eb" }}>{Math.floor(totalPendingSum / 1000).toLocaleString("vi-VN")}</span>
                                            </div>
                                        </div>
                                        <div style={{ backgroundColor: "#f0fdf4", border: "1px solid #dcfce7", borderRadius: "12px", padding: "14px 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                                            <span style={{ fontSize: "12.5px", fontWeight: 600, color: "#16a34a" }}>Thành công</span>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <span style={{ fontSize: "20px", color: "#16a34a", display: "flex", alignItems: "center" }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><path d="M22 4L12 14.01l-3-3" /></svg>
                                                </span>
                                                <span style={{ fontSize: "22px", fontWeight: 700, color: "#16a34a" }}>{Math.floor(totalSuccessSum / 1000).toLocaleString("vi-VN")}</span>
                                            </div>
                                        </div>
                                        <div style={{ backgroundColor: "#fef2f2", border: "1px solid #fee2e2", borderRadius: "12px", padding: "14px 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                                            <span style={{ fontSize: "12.5px", fontWeight: 600, color: "#dc2626" }}>Thất bại</span>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <span style={{ fontSize: "20px", color: "#dc2626", display: "flex", alignItems: "center" }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2"><path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                                </span>
                                                <span style={{ fontSize: "22px", fontWeight: 700, color: "#dc2626" }}>{Math.floor(totalFailedSum / 1000).toLocaleString("vi-VN")}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* TABLE (SPACIOUS & RESPONSIVE, MATCHING IMAGE 3) */}
                                    {(() => {
                                        const isBankModal = subModalType === "nap" || subModalType === "rut";
                                        const colCount = isBankModal ? 10 : 8;

                                        return (
                                            <div className="ax-table-wrapper" style={{ width: "100%", overflowX: "auto" }}>
                                                <Table style={{ width: "100%", tableLayout: "auto", borderCollapse: "collapse" }}>
                                                    <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                                                        <TableRow>
                                                            <TableCell sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Mã giao dịch</TableCell>
                                                            <TableCell sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Loại</TableCell>
                                                            <TableCell sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Số điểm</TableCell>
                                                            <TableCell align="center" sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Trạng thái</TableCell>
                                                            <TableCell sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Ghi chú</TableCell>
                                                            {isBankModal && (
                                                                <>
                                                                    <TableCell align="center" sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Ngân hàng/ Mạng</TableCell>
                                                                    <TableCell align="center" sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Số tài khoản/ Địa chỉ</TableCell>
                                                                </>
                                                            )}
                                                            <TableCell align="center" sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Tên tài khoản</TableCell>
                                                            <TableCell sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Nội dung chuyển khoản</TableCell>
                                                            <TableCell align="center" sx={{ padding: "12px 10px", color: "#334155 !important", fontWeight: "600 !important", fontSize: "12.5px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>Ngày tạo</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {loadingSubHistory ? (
                                                            <TableRow>
                                                                <TableCell colSpan={colCount} align="center" sx={{ py: 4, color: "#64748b" }}>Đang tải lịch sử...</TableCell>
                                                            </TableRow>
                                                        ) : filteredData.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={colCount} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                                                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
                                                                        <span style={{ fontSize: "13px", color: "#94a3b8" }}>Trống</span>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            filteredData.map((item, idx) => {
                                                                const cat = getItemStatusCategory(item);
                                                                const isSuccess = cat === "Success";
                                                                const isFailed = cat === "Deny";
                                                                const statusText = isSuccess ? "Thành công" : isFailed ? "Thất bại" : "Chờ xử lý";

                                                                // Transaction Code
                                                                let rawTransCode = item.orderNo || item.code || item.trans_id || item.transactionid || item.phien || item.id_bet || item._id || "-";
                                                                if (typeof rawTransCode === 'object') {
                                                                    rawTransCode = rawTransCode.orderNo || rawTransCode._id || String(rawTransCode);
                                                                }
                                                                const transCode = String(rawTransCode || "-");

                                                                // Parse Bank, STK, Account Name, and Content
                                                                let bankName = item.bank_name || item.bank || item.channel || "-";
                                                                let accountNumber = item.stk || item.bank_account || item.account_number || item.bank_number || "-";
                                                                let accountName = item.account_name || item.name || item.bank_user || selectedUser?.username || "-";
                                                                let rawTransferContent = item.code || item.noidung || item.content || item.detail || "";

                                                                if (typeof rawTransferContent === "object") {
                                                                    rawTransferContent = rawTransferContent.code || rawTransferContent.noidung || "";
                                                                }
                                                                let transferContent = String(rawTransferContent || "").trim();

                                                                const rawDetail = String(item.detail || "").trim();
                                                                if (rawDetail && rawDetail.includes(" - ")) {
                                                                    const parts = rawDetail.split(" - ");
                                                                    if (parts.length >= 3) {
                                                                        if (bankName === "-" || bankName === "Ngân hàng") bankName = parts[0].trim();
                                                                        if (accountName === "-" || accountName === selectedUser?.username) accountName = parts[1].trim();
                                                                        if (accountNumber === "-") accountNumber = parts.slice(2).join(" - ").trim();
                                                                    } else if (parts.length === 2) {
                                                                        if (bankName === "-" || bankName === "Ngân hàng") bankName = parts[0].trim();
                                                                        const p2 = parts[1].trim();
                                                                        if (/^RefId:/i.test(p2) || /^code:/i.test(p2)) {
                                                                            if (!transferContent || transferContent === rawDetail) transferContent = p2;
                                                                        } else {
                                                                            if (accountNumber === "-") accountNumber = p2;
                                                                        }
                                                                    }
                                                                }

                                                                // Clean RefId prefix from transfer content
                                                                if (transferContent) {
                                                                    transferContent = transferContent.replace(/^RefId:\s*/i, "").replace(/^code:\s*/i, "").trim();
                                                                }
                                                                if (!transferContent || transferContent === "undefined") {
                                                                    transferContent = item.code ? String(item.code).replace(/^RefId:\s*/i, "").trim() : (item.noidung || "-");
                                                                }

                                                                // Parse Clean Note matching Image 3
                                                                let cleanNote = item.note || statusText;
                                                                if (isFailed && (!item.note || /^Nạp/i.test(item.note) || item.note === "Thất bại" || item.note === "Từ chối")) {
                                                                    cleanNote = "Quá hạn";
                                                                } else if (isSuccess && (!item.note || /^Nạp/i.test(item.note))) {
                                                                    cleanNote = "Thành công";
                                                                }

                                                                const rawTime = item.time || item.createdAt;
                                                                let formattedDateStr = "-";
                                                                if (rawTime) {
                                                                    const d = new Date(rawTime);
                                                                    if (!isNaN(d.getTime())) {
                                                                        const hh = String(d.getHours()).padStart(2, '0');
                                                                        const mm = String(d.getMinutes()).padStart(2, '0');
                                                                        const DD = String(d.getDate()).padStart(2, '0');
                                                                        const MM = String(d.getMonth() + 1).padStart(2, '0');
                                                                        const YYYY = d.getFullYear();
                                                                        formattedDateStr = `${hh}:${mm} ${DD}-${MM}-${YYYY}`;
                                                                    } else {
                                                                        formattedDateStr = String(rawTime);
                                                                    }
                                                                }

                                                                return (
                                                                    <TableRow key={idx} sx={{ '&:hover': { backgroundColor: '#f8fafc' } }}>
                                                                        <TableCell sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                            {transCode}
                                                                        </TableCell>
                                                                        <TableCell sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap", fontWeight: 600 }}>
                                                                            {item.type || (subModalType === "nap" ? "NAP" : subModalType === "rut" ? "RÚT" : item.game || subModalType.toUpperCase())}
                                                                        </TableCell>
                                                                        <TableCell sx={{ padding: "10px 8px", fontSize: "12.5px", fontWeight: 600, color: "#334155", whiteSpace: "nowrap" }}>
                                                                            {Math.floor((item.money || item.money_recv || 0) / 1000).toLocaleString("vi-VN")}
                                                                        </TableCell>
                                                                        <TableCell align="center" sx={{ padding: "10px 8px", whiteSpace: "nowrap" }}>
                                                                            <span style={{
                                                                                color: isSuccess ? "#16a34a" : isFailed ? "#dc2626" : "#d97706",
                                                                                backgroundColor: isSuccess ? "#f0fdf4" : isFailed ? "#fef2f2" : "#fffbeb",
                                                                                border: isSuccess ? "1px solid #dcfce7" : isFailed ? "1px solid #fee2e2" : "1px solid #fef3c7",
                                                                                padding: "2px 8px",
                                                                                borderRadius: "4px",
                                                                                fontSize: "11.5px",
                                                                                fontWeight: 500,
                                                                                display: "inline-block"
                                                                            }}>
                                                                                {statusText}
                                                                            </span>
                                                                        </TableCell>
                                                                        <TableCell sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                            {cleanNote}
                                                                        </TableCell>
                                                                        {isBankModal && (
                                                                            <>
                                                                                <TableCell align="center" sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                                    {bankName}
                                                                                </TableCell>
                                                                                <TableCell align="center" sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                                    {accountNumber}
                                                                                </TableCell>
                                                                            </>
                                                                        )}
                                                                        <TableCell align="center" sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                            {accountName}
                                                                        </TableCell>
                                                                        <TableCell sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                            {transferContent}
                                                                        </TableCell>
                                                                        <TableCell align="center" sx={{ padding: "10px 8px", fontSize: "12.5px", color: "#334155", whiteSpace: "nowrap" }}>
                                                                            {formattedDateStr}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        );
                                    })()}

                                    {/* PAGINATION */}
                                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "4px", marginTop: "16px" }}>
                                        <button style={{ border: "1px solid #e2e8f0", backgroundColor: "#ffffff", color: "#94a3b8", width: "28px", height: "28px", borderRadius: "4px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>&lt;</button>
                                        <button style={{ border: "1px solid #3b82f6", backgroundColor: "#eff6ff", color: "#2563eb", width: "28px", height: "28px", borderRadius: "4px", fontWeight: 600, fontSize: "12px" }}>1</button>
                                        <button style={{ border: "1px solid #e2e8f0", backgroundColor: "#ffffff", color: "#94a3b8", width: "28px", height: "28px", borderRadius: "4px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>&gt;</button>
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                )}

                {/* AX68WIN HƯỚNG DẪN CHI TIẾT MODAL */}
                {openUserGuideModal && (
                    <div className="ax-modal-overlay" onClick={() => setOpenUserGuideModal(false)} style={{ zIndex: 12000 }}>
                        <div className="ax-modal-card" onClick={(e) => e.stopPropagation()} style={{ background: "#ffffff", maxWidth: "620px", borderRadius: "12px", boxShadow: "0 20px 40px rgba(0,0,0,0.3)" }}>
                            <div className="ax-modal-header" style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", padding: "18px 24px", borderBottom: "1px solid #f0f0f0" }}>
                                <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#111827", textAlign: "center", flexGrow: 1 }}>Hướng dẫn chi tiết</h3>
                                <span className="close-icon" style={{ position: "absolute", right: "20px", top: "50%", transform: "translateY(-50%)", fontSize: "18px", color: "#6b7280", cursor: "pointer" }} onClick={() => setOpenUserGuideModal(false)}>✕</span>
                            </div>
                            <div className="ax-modal-body" style={{ padding: "24px 28px", maxHeight: "72vh", overflowY: "auto", fontSize: "14px", color: "#374151", textAlign: "left" }}>
                                <div style={{ marginBottom: "16px", textAlign: "left" }}>
                                    <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>Tên người chơi</h4>
                                    <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                        <li style={{ textAlign: "left" }}>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Tên người chơi' đã nhập vào ô văn bản.</li>
                                    </ul>
                                </div>

                                <div style={{ marginBottom: "16px", textAlign: "left" }}>
                                    <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>Họ và tên</h4>
                                    <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                        <li style={{ textAlign: "left" }}>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Họ và tên' đã nhập vào ô văn bản.</li>
                                    </ul>
                                </div>

                                <div style={{ marginBottom: "16px", textAlign: "left" }}>
                                    <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>Mật khẩu</h4>
                                    <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                        <li style={{ textAlign: "left" }}>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Mật khẩu' đã nhập vào ô văn bản.</li>
                                    </ul>
                                </div>

                                <div style={{ marginBottom: "16px", textAlign: "left" }}>
                                    <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>Mật khẩu rút điểm</h4>
                                    <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                        <li style={{ textAlign: "left" }}>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Mật khẩu rút điểm' đã nhập vào ô văn bản.</li>
                                    </ul>
                                </div>

                                <div style={{ marginBottom: "16px", textAlign: "left" }}>
                                    <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>Làm mới</h4>
                                    <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                        <li style={{ textAlign: "left" }}>Hiển thị dữ liệu mới nhất.</li>
                                    </ul>
                                </div>

                                <div style={{ marginBottom: "16px", textAlign: "left" }}>
                                    <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>Xuất excel</h4>
                                    <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                        <li style={{ textAlign: "left" }}>Được sử dụng để xuất một file excel với tất cả dữ liệu là các thông tin được hiển thị trên bảng kết quả trên màn hình.</li>
                                        <li style={{ textAlign: "left" }}>Lưu ý: Không thể xuất file của dữ liệu rỗng.</li>
                                    </ul>
                                </div>

                                <div style={{ textAlign: "left" }}>
                                    <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>Chỉnh sửa</h4>
                                    <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                        <li style={{ textAlign: "left" }}>Cho phép xem hoặc thay đổi dữ liệu với kết quả được chọn.</li>
                                        <li style={{ textAlign: "left" }}>Lưu ý: Việc thay đổi kết quả hiện tại thành một kết quả mới phải tuân thủ quy tắc đặt ra (nếu có).</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="ax-modal-footer" style={{ padding: "14px 24px", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "flex-end" }}>
                                <button className="ax-btn-modal-close" style={{ backgroundColor: "#d9534f", color: "#fff", border: "none", padding: "8px 24px", borderRadius: "6px", fontWeight: "600", fontSize: "14px", cursor: "pointer" }} onClick={() => setOpenUserGuideModal(false)}>
                                    Đóng
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </DashboardLayout>
        </ThemeProvider>
    );
}
export default Users;
